var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentorHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_87502",
    "data-name": "Group 87502",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 488,
    height: 438.866,
    viewBox: "0 0 488 438.866",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25370",
    "data-name": "Rectangle 25370",
    width: 488,
    height: 438.866,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25369",
    "data-name": "Rectangle 25369",
    width: 487.998,
    height: 438.864,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25307",
    "data-name": "Rectangle 25307",
    width: 59.963,
    height: 52.189,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25308",
    "data-name": "Rectangle 25308",
    width: 46.532,
    height: 28.942,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25339",
    "data-name": "Rectangle 25339",
    width: 75.879,
    height: 71.633,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25340",
    "data-name": "Rectangle 25340",
    width: 65.018,
    height: 71.632,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25341",
    "data-name": "Rectangle 25341",
    width: 49.896,
    height: 88.247,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25342",
    "data-name": "Rectangle 25342",
    width: 15.031,
    height: 77.816,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25343",
    "data-name": "Rectangle 25343",
    width: 53.787,
    height: 82.137,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25344",
    "data-name": "Rectangle 25344",
    width: 13.672,
    height: 3.151,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25347",
    "data-name": "Rectangle 25347",
    width: 78.285,
    height: 175.16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25351",
    "data-name": "Rectangle 25351",
    width: 221.316,
    height: 24.333,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25352",
    "data-name": "Rectangle 25352",
    width: 220.817,
    height: 0.594,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25355",
    "data-name": "Rectangle 25355",
    width: 10.532,
    height: 175.16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25361",
    "data-name": "Rectangle 25361",
    width: 50.839,
    height: 54.504,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25362",
    "data-name": "Rectangle 25362",
    width: 43.659,
    height: 46.111,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25363",
    "data-name": "Rectangle 25363",
    width: 36.144,
    height: 34.754,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87501",
    "data-name": "Group 87501",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87500",
    "data-name": "Group 87500",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87499",
    "data-name": "Group 87499",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275647",
    "data-name": "Path 275647",
    d: "M145.379,35.39A35.39,35.39,0,1,1,109.988,0a35.391,35.391,0,0,1,35.39,35.39",
    transform: "translate(294.331 -0.002)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275648",
    "data-name": "Path 275648",
    d: "M142.791,34.255A33.768,33.768,0,1,1,109.022.487a33.768,33.768,0,0,1,33.768,33.768",
    transform: "translate(296.919 1.919)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275649",
    "data-name": "Path 275649",
    d: "M138.958,32.555A31.637,31.637,0,1,1,107.322.918a31.637,31.637,0,0,1,31.637,31.637",
    transform: "translate(298.62 3.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87453",
    "data-name": "Group 87453",
    transform: "translate(376.897 8.171)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87452",
    "data-name": "Group 87452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87451",
    "data-name": "Group 87451",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275650",
    "data-name": "Path 275650",
    d: "M136.174,22.944c-14.406,8.729-38.086,23.046-51.32,30.9a31.725,31.725,0,0,1-8.645-11.627L119.982,1.653a31.67,31.67,0,0,1,16.192,21.291",
    transform: "translate(-76.21 -1.651)",
    fill: "#ececec"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87456",
    "data-name": "Group 87456",
    transform: "translate(391.023 37.281)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87455",
    "data-name": "Group 87455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87454",
    "data-name": "Group 87454",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275651",
    "data-name": "Path 275651",
    d: "M125.6,7.539a31.292,31.292,0,0,1-2.092,10.282L84.05,36.48a31.6,31.6,0,0,1-4.985-2.141c11.919-6.889,33.7-19.421,46.533-26.8",
    transform: "translate(-79.067 -7.537)",
    fill: "#ececec"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25309",
    "data-name": "Rectangle 25309",
    width: 0.613,
    height: 4.797,
    transform: "translate(405.635 6.835)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275652",
    "data-name": "Path 275652",
    d: "M81.46,6.607l-2.4-4.154.529-.307L81.99,6.3Z",
    transform: "translate(311.943 8.466)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275653",
    "data-name": "Path 275653",
    d: "M81.067,7.223l-4.154-2.4.307-.529,4.154,2.4Z",
    transform: "translate(303.464 16.946)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25310",
    "data-name": "Rectangle 25310",
    width: 4.797,
    height: 0.613,
    transform: "translate(376.599 35.87)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275654",
    "data-name": "Path 275654",
    d: "M77.22,12.671l-.307-.529,4.154-2.4.307.529Z",
    transform: "translate(303.464 38.441)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275655",
    "data-name": "Path 275655",
    d: "M79.591,16.043l-.529-.307,2.4-4.154.529.307Z",
    transform: "translate(311.944 45.696)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25311",
    "data-name": "Rectangle 25311",
    width: 0.613,
    height: 4.797,
    transform: "translate(405.635 60.722)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275656",
    "data-name": "Path 275656",
    d: "M86.908,16.043l-2.4-4.154.529-.307,2.4,4.154Z",
    transform: "translate(333.438 45.696)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275657",
    "data-name": "Path 275657",
    d: "M90.5,12.671l-4.154-2.4.307-.529,4.154,2.4Z",
    transform: "translate(340.695 38.441)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25312",
    "data-name": "Rectangle 25312",
    width: 4.797,
    height: 0.613,
    transform: "translate(430.486 35.87)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275658",
    "data-name": "Path 275658",
    d: "M86.656,7.223l-.307-.529L90.5,4.3l.307.529Z",
    transform: "translate(340.695 16.946)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275659",
    "data-name": "Path 275659",
    d: "M85.039,6.607,84.51,6.3l2.4-4.154.529.307Z",
    transform: "translate(333.439 8.466)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275660",
    "data-name": "Path 275660",
    d: "M83.737,1.83l1.039,29.3-3-.035L82.921,1.82Z",
    transform: "translate(322.663 7.178)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275661",
    "data-name": "Path 275661",
    d: "M102.737,5.821,83.019,18.4,81.59,15.767,102.346,5.1Z",
    transform: "translate(321.917 20.136)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275662",
    "data-name": "Path 275662",
    d: "M83.922,8.132A1.024,1.024,0,1,1,82.9,7.108a1.026,1.026,0,0,1,1.024,1.024",
    transform: "translate(323.043 28.043)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25313",
    "data-name": "Rectangle 25313",
    width: 124.559,
    height: 7.394,
    transform: "translate(34.733 54.985)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25314",
    "data-name": "Rectangle 25314",
    width: 7.399,
    height: 24.461,
    transform: "translate(142.437 62.378)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25315",
    "data-name": "Rectangle 25315",
    width: 7.399,
    height: 7.562,
    transform: "translate(142.437 62.378)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25316",
    "data-name": "Rectangle 25316",
    width: 7.399,
    height: 24.461,
    transform: "translate(44.184 62.378)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25317",
    "data-name": "Rectangle 25317",
    width: 7.399,
    height: 7.562,
    transform: "translate(44.184 62.378)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25318",
    "data-name": "Rectangle 25318",
    width: 11.869,
    height: 47.136,
    transform: "translate(115.944 7.849)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25319",
    "data-name": "Rectangle 25319",
    width: 11.869,
    height: 5.178,
    transform: "translate(115.944 5.326)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25320",
    "data-name": "Rectangle 25320",
    width: 11.869,
    height: 1.924,
    transform: "translate(115.944 17.141)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25321",
    "data-name": "Rectangle 25321",
    width: 13.348,
    height: 5.178,
    transform: "translate(114.465 43.62)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25322",
    "data-name": "Rectangle 25322",
    width: 8.294,
    height: 54.985,
    transform: "translate(107.645)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25323",
    "data-name": "Rectangle 25323",
    width: 4.98,
    height: 21.147,
    transform: "translate(109.336 5.168)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25324",
    "data-name": "Rectangle 25324",
    width: 54.985,
    height: 8.295,
    transform: "matrix(0.711, -0.703, 0.703, 0.711, 48.626, 49.092)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25325",
    "data-name": "Rectangle 25325",
    width: 21.149,
    height: 4.978,
    transform: "matrix(0.711, -0.703, 0.703, 0.711, 58.949, 41.183)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25326",
    "data-name": "Rectangle 25326",
    width: 14.09,
    height: 41.765,
    transform: "translate(93.56 13.224)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25327",
    "data-name": "Rectangle 25327",
    width: 14.09,
    height: 3.892,
    transform: "translate(93.56 46.671)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25328",
    "data-name": "Rectangle 25328",
    width: 14.09,
    height: 1.508,
    transform: "translate(93.56 42.606)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25329",
    "data-name": "Rectangle 25329",
    width: 9.733,
    height: 39.253,
    transform: "translate(127.808 15.742)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25330",
    "data-name": "Rectangle 25330",
    width: 9.733,
    height: 3.66,
    transform: "translate(127.808 47.171)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25331",
    "data-name": "Rectangle 25331",
    width: 9.733,
    height: 3.66,
    transform: "translate(127.808 23.833)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25332",
    "data-name": "Rectangle 25332",
    width: 9.733,
    height: 1.419,
    transform: "translate(127.808 29.995)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275663",
    "data-name": "Path 275663",
    d: "M43.465,0h58.348V58.348H43.465Zm2.75,55.593H99.058V2.75H46.215Z",
    transform: "translate(171.494 -0.002)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25333",
    "data-name": "Rectangle 25333",
    width: 41.187,
    height: 18.269,
    transform: "translate(225.562 27.092)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25334",
    "data-name": "Rectangle 25334",
    width: 13.798,
    height: 39.861,
    transform: "translate(226.788 86.241)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25335",
    "data-name": "Rectangle 25335",
    width: 29.001,
    height: 17.329,
    transform: "translate(223.569 160.033)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275664",
    "data-name": "Path 275664",
    d: "M43.465,15.172h58.348V73.52H43.465Zm2.75,55.6H99.058V17.927H46.215Z",
    transform: "translate(171.494 59.86)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275665",
    "data-name": "Path 275665",
    d: "M43.465,30.345h58.348V88.693H43.465Zm2.75,55.6H99.058V33.1H46.215Z",
    transform: "translate(171.494 119.726)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25336",
    "data-name": "Rectangle 25336",
    width: 21.103,
    height: 21.103,
    transform: "translate(233.579 18.62)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25337",
    "data-name": "Rectangle 25337",
    width: 21.103,
    height: 21.103,
    transform: "translate(233.579 93.659)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25338",
    "data-name": "Rectangle 25338",
    width: 21.103,
    height: 21.103,
    transform: "translate(233.579 168.698)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275666",
    "data-name": "Path 275666",
    d: "M33.391,71.973c-9.753.247-19.876.371-29.94.45l0-.45L3.337,59.51c.015-.648-.168-.569.559-.559l29.5.262.3,0-.01.292Zm0,0-.3-12.463.3.292-29.5.262.554-.554L4.336,71.973l-.44-.445c9.733.079,19.441.2,29.5.445h0",
    transform: "translate(13.127 232.562)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275667",
    "data-name": "Path 275667",
    d: "M30.063,75.151c-9.748.247-19.876.371-29.94.45l0-.45L.009,62.688c.02-.648-.173-.569.559-.559l29.5.262.3,0,0,.292Zm0,0-.3-12.463.3.292-29.5.262.554-.554L1.008,75.151l-.44-.445c9.733.079,19.441.2,29.5.445h0",
    transform: "translate(0.001 245.101)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275668",
    "data-name": "Path 275668",
    d: "M93.3,34.486c-9.748.247-19.876.371-29.935.45l0-.45-.114-12.463c.02-.648-.173-.569.559-.559l29.5.262.3,0,0,.292Zm0,0-.3-12.463.3.292-29.5.262.554-.554-.114,12.463-.44-.445c9.733.079,19.441.2,29.5.445h0",
    transform: "translate(249.518 84.655)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275669",
    "data-name": "Path 275669",
    d: "M89.976,37.664c-9.748.247-19.876.371-29.935.45l0-.45L59.922,25.2c.02-.648-.173-.569.559-.559l29.5.262.3,0,0,.292Zm0,0L89.68,25.2l.3.292-29.5.262.554-.554-.114,12.463-.44-.445c9.738.079,19.441.2,29.5.445h0",
    transform: "translate(236.391 97.194)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275670",
    "data-name": "Path 275670",
    d: "M86.662,34.486c-9.748.247-19.876.371-29.935.45l0-.45-.114-12.463c.02-.648-.173-.569.559-.559l29.5.262.3,0,0,.292Zm0,0-.3-12.463.3.292-29.5.262.554-.554-.114,12.463-.44-.445c9.733.079,19.441.2,29.5.445h0",
    transform: "translate(223.315 84.655)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275671",
    "data-name": "Path 275671",
    d: "M122.6,75.151c-9.748.247-19.876.371-29.94.45v-.45l-.114-12.463c.02-.648-.173-.569.559-.559l29.5.262.3,0-.005.292Zm0,0-.3-12.463.3.292-29.5.262.554-.554-.114,12.463-.44-.445c9.733.079,19.441.2,29.5.445h0",
    transform: "translate(365.099 245.101)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275672",
    "data-name": "Path 275672",
    d: "M119.27,13.509c-9.748.247-19.876.371-29.935.45l0-.45L89.216,1.046c.02-.648-.173-.569.559-.559l29.5.262.3,0,0,.292Zm0,0-.3-12.463.3.292-29.5.262.554-.554-.114,12.463-.44-.445c9.733.079,19.441.2,29.5.445h0",
    transform: "translate(351.972 1.889)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275673",
    "data-name": "Path 275673",
    d: "M122.6,16.687c-9.748.247-19.876.371-29.94.45v-.45L92.543,4.224c.02-.648-.173-.569.559-.559l29.5.262.3,0-.005.292Zm0,0-.3-12.463.3.292-29.5.262.554-.554-.114,12.463-.44-.445c9.733.079,19.441.2,29.5.445h0",
    transform: "translate(365.099 14.428)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275674",
    "data-name": "Path 275674",
    d: "M33.39,13.51c-9.753.247-19.876.371-29.94.45l0-.45L3.336,1.047C3.356.394,3.163.478,3.9.488L33.39.75l.3,0-.01.292Zm0,0-.3-12.463.3.292L3.9,1.6l.554-.554L4.335,13.51l-.44-.445c9.733.079,19.441.2,29.5.445h0",
    transform: "translate(13.128 1.889)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275675",
    "data-name": "Path 275675",
    d: "M473.475,101.038c0,11.4-105.622,20.648-235.913,20.648S1.649,112.442,1.649,101.038,107.276,80.39,237.562,80.39s235.913,9.243,235.913,20.648",
    transform: "translate(6.506 317.181)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275676",
    "data-name": "Path 275676",
    d: "M1.043,76.233c119.124-.529,358.845-.529,477.944,0-119.129.529-358.85.529-477.944,0",
    transform: "translate(4.115 299.212)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275677",
    "data-name": "Path 275677",
    d: "M24.636,59.022l2.517,15.094L44.2,166.187h2.75l-12.4-92.071-1.83-15.094Z",
    transform: "translate(97.204 232.872)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275678",
    "data-name": "Path 275678",
    d: "M32.722,59.022H24.636l2.517,15.094h7.4Z",
    transform: "translate(97.203 232.872)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275679",
    "data-name": "Path 275679",
    d: "M13.81,166.187h2.75L33.607,74.116l2.517-15.094H28.039l-1.83,15.094Z",
    transform: "translate(54.49 232.872)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275680",
    "data-name": "Path 275680",
    d: "M18.148,59.022l-1.83,15.094h7.4l2.517-15.094Z",
    transform: "translate(64.382 232.872)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275681",
    "data-name": "Path 275681",
    d: "M3.47,166.187H6.22L23.267,74.116l2.517-15.094H17.7l-1.83,15.094Z",
    transform: "translate(13.691 232.872)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275682",
    "data-name": "Path 275682",
    d: "M5.977,74.116h7.4l2.517-15.094H7.807Z",
    transform: "translate(23.582 232.872)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275683",
    "data-name": "Path 275683",
    d: "M4.351,143.916h124.93V130.751H82.516L66.8,39.3H9.114Z",
    transform: "translate(17.169 155.07)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275684",
    "data-name": "Path 275684",
    d: "M4.351,143.916h6.81L15.6,39.3H9.114Z",
    transform: "translate(17.169 155.07)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275685",
    "data-name": "Path 275685",
    d: "M88.41,147.766c-2.483.312-70.286-15.509-72.492-17.641-.267-.237,2.938-13.259,2.938-13.259,1.068-5.356,18.724-49.085,18.724-49.085L81.906,78.716,63.123,119.249s8.452,5.717,15.712,11.172l.02.025c4.481,3.348,8.353,6.36,9.184,7.344,2.156,2.582,2.854,9.683.371,9.975",
    transform: "translate(62.741 267.432)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275686",
    "data-name": "Path 275686",
    d: "M88.4,120.43c-2.483.312-70.286-15.5-72.487-17.641-.267-.237,2.943-13.259,2.943-13.259.356-1.756,2.493-7.671,5.218-14.822L66.506,84.6l-3.388,7.31s8.452,5.727,15.717,11.182l.01.02c4.486,3.343,8.363,6.365,9.189,7.349,2.161,2.582,2.854,9.678.371,9.97",
    transform: "translate(62.742 294.763)",
    fill: "#ffe7ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275687",
    "data-name": "Path 275687",
    d: "M89.027,116.118c-2.567.267-70.919-15.049-73.15-17.285C15.017,98,21.08,75.98,21.11,75.851l43.748,9.664-.183.742s21.983,16.854,24.174,19.57,2.745,10.035.178,10.292",
    transform: "translate(62.316 299.272)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275688",
    "data-name": "Path 275688",
    d: "M86.068,95.633c-11.459-2.863-57.947-13.343-69.49-15.3-.094-.02-.109.044-.015.069,11.3,3.091,57.863,13.19,69.465,15.42.242.049.282-.129.04-.188",
    transform: "translate(65.098 316.934)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275689",
    "data-name": "Path 275689",
    d: "M37.8,79.188c-4.342-1.859-10.044-2.408-14.233.04-.163.094-.025.326.129.312a65.515,65.515,0,0,1,13.956.218.3.3,0,0,0,.148-.569",
    transform: "translate(92.701 306.123)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275690",
    "data-name": "Path 275690",
    d: "M38.374,79.735c-4.342-1.86-10.044-2.408-14.233.04-.163.094-.025.326.129.312a65.191,65.191,0,0,1,13.956.218.3.3,0,0,0,.148-.569",
    transform: "translate(94.958 308.281)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275691",
    "data-name": "Path 275691",
    d: "M38.946,80.281c-4.342-1.859-10.044-2.408-14.233.04-.163.094-.025.326.129.312A65.194,65.194,0,0,1,38.8,80.85a.3.3,0,0,0,.148-.569",
    transform: "translate(97.215 310.435)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275692",
    "data-name": "Path 275692",
    d: "M41.1,77.927c-1.231-2.849-4.8-2.488-7.047-1.325a24.738,24.738,0,0,0-9.312,8.808.12.12,0,0,0,.069.183.577.577,0,0,0,.584.727c4.055-.544,8.457-.628,12.225-2.4,2.2-1.034,4.644-3.3,3.482-5.994m-9.728,6.311c-1.988.317-3.981.534-5.954.925a73.233,73.233,0,0,1,5.554-5.025,26.146,26.146,0,0,1,2.982-2.052c1.627-.925,7.552-2.334,5.638,2.453-1.058,2.641-5.851,3.323-8.22,3.7",
    transform: "translate(97.52 298.828)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275693",
    "data-name": "Path 275693",
    d: "M24.783,83.4c3.383,2.428,7.7,3.309,11.582,4.585.4.134.707-.252.707-.608a.122.122,0,0,0,.1-.168,24.752,24.752,0,0,0-7.552-10.356c-2-1.558-5.44-2.557-7.166.02-1.642,2.438.351,5.109,2.324,6.528m-1.32-3.689c-1.009-5.059,4.56-2.591,5.989-1.385a26.655,26.655,0,0,1,2.562,2.562,74.451,74.451,0,0,1,4.54,5.954c-1.869-.747-3.788-1.32-5.687-2-2.26-.8-6.85-2.344-7.4-5.133",
    transform: "translate(86.215 297.072)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275694",
    "data-name": "Path 275694",
    d: "M90.893,206.027,43.6,195.438s39-90.484,35.549-95.059c-1.726-2.29-45.539-2.962-59.47-14.767-18.1-15.331-5.954-38.763-5.954-38.763L62.654,45.4s-.593,10.218,1.316,11.761c1.261,1.024,59.559,5.925,65.959,25.569,7.854,24.09-39.035,123.3-39.035,123.3",
    transform: "translate(38.434 179.126)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275695",
    "data-name": "Path 275695",
    d: "M60.2,84.846c-1.251-.524-13.462-3.986-16.2-4.688-5.5-1.4-11.019-2.794-16.553-4.09-2.883-.678-9.07-2.151-9.441-2.122a.153.153,0,0,0-.025.3c5.4,1.681,10.846,3.15,16.3,4.639s24.184,6.063,25.811,6.241c.158.02.287-.208.109-.282",
    transform: "translate(70.484 291.756)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275696",
    "data-name": "Path 275696",
    d: "M82.781,92.557c-.984-.841-2.458-.945-3.694-1.147Q68.494,89.637,57.9,87.859c-6.607-1.108-13.249-2.1-19.827-3.363-5.45-1.053-10.989-2.468-15.7-5.42a22.784,22.784,0,0,1-9.619-12.581,40.685,40.685,0,0,1-1.246-16.123c.129-1.316.371-2.626.613-3.922.02-.1-.138-.134-.153-.035-1.79,10.02-1.953,21.652,5.564,29.634,3.66,3.892,8.694,6.182,13.828,7.661,5.8,1.677,11.85,2.468,17.794,3.457Q59.745,88.94,70.343,90.7c3.4.564,6.85,1.009,10.218,1.711a3.453,3.453,0,0,1,1.84.816,2.633,2.633,0,0,1,.3,2.448c-.341,1.662-.791,3.3-1.266,4.936C77.579,113.769,51.56,176.533,50.8,177.977c-.084.153.158.272.242.124,6.479-11.538,25.331-60.014,29.609-72.457a78.885,78.885,0,0,0,2.779-9.683c.242-1.187.386-2.522-.648-3.4",
    transform: "translate(43.172 182.898)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275697",
    "data-name": "Path 275697",
    d: "M118.57,139.059c-2.374.8-70.237-.158-72.818-1.81-1-.954-1.8-9.634-2.413-20.43L31.662,70.533l43.659-.361,12.784,45.969s9.421,3.922,17.626,7.824l.02.02c5.064,2.389,9.456,4.57,10.47,5.376,2.621,2.1,4.723,8.922,2.349,9.7",
    transform: "translate(124.924 276.866)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275698",
    "data-name": "Path 275698",
    d: "M110.976,104.11c-2.453.811-72.5.475-75.158-1.231-1.024-.628-1.568-10.826-1.874-23.165,0-.129,0-.257,0-.386l45.2-.287-.025.767s26.76,12.1,29.485,14.288c2.7,2.176,4.832,9.214,2.379,10.015",
    transform: "translate(133.908 311.859)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275699",
    "data-name": "Path 275699",
    d: "M106.188,83.87c-11.805-.346-59.46-.628-71.162-.074-.094,0-.094.069,0,.074,11.7.6,59.352.495,71.162.193.247,0,.247-.183,0-.193",
    transform: "translate(137.92 329.384)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275700",
    "data-name": "Path 275700",
    d: "M55.221,79.356c-4.644-.89-10.331-.2-13.9,3.086-.138.129.045.321.2.277A65.321,65.321,0,0,1,55.2,79.94a.3.3,0,0,0,.02-.584",
    transform: "translate(162.853 311.697)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275701",
    "data-name": "Path 275701",
    d: "M55.9,79.768c-4.644-.89-10.331-.2-13.9,3.086-.138.129.045.321.2.277a65.325,65.325,0,0,1,13.679-2.779.3.3,0,0,0,.02-.584",
    transform: "translate(165.52 313.322)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275702",
    "data-name": "Path 275702",
    d: "M56.574,80.179c-4.644-.89-10.331-.2-13.9,3.086-.138.129.045.321.2.277a65.327,65.327,0,0,1,13.679-2.779.3.3,0,0,0,.02-.584",
    transform: "translate(168.192 314.944)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275703",
    "data-name": "Path 275703",
    d: "M56.8,78.216c-1.81-2.522-5.218-1.4-7.166.213a24.731,24.731,0,0,0-7.206,10.593.122.122,0,0,0,.109.168.578.578,0,0,0,.727.584c3.843-1.4,8.126-2.423,11.424-4.96,1.924-1.479,3.828-4.214,2.112-6.6m-8.145,8.244c-1.874.732-3.773,1.375-5.618,2.176a72.877,72.877,0,0,1,4.347-6.093A26.086,26.086,0,0,1,49.856,79.9c1.39-1.251,6.874-3.9,6.034,1.187-.465,2.809-5,4.5-7.235,5.376",
    transform: "translate(167.363 302.748)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275704",
    "data-name": "Path 275704",
    d: "M43.17,85.492c3.823,1.647,8.224,1.587,12.295,2a.581.581,0,0,0,.564-.747.121.121,0,0,0,.059-.188,24.751,24.751,0,0,0-9.594-8.5c-2.285-1.088-5.86-1.33-7,1.558-1.078,2.73,1.444,4.911,3.675,5.875m-2.082-3.318c-2.072-4.723,3.9-3.506,5.554-2.636A26.668,26.668,0,0,1,49.693,81.5,74.023,74.023,0,0,1,55.4,86.338c-1.988-.326-3.986-.48-5.984-.732-2.379-.3-7.191-.826-8.333-3.432",
    transform: "translate(154.816 305.007)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275705",
    "data-name": "Path 275705",
    d: "M184.321,212.7l-50.944-.04s-21.8-86.5-25.663-91.433c-5.148-6.568-77.136-6.419-92.576-27.848C1.271,74.139,12.977,46.9,12.977,46.9l54.515-1.617a112.179,112.179,0,0,1-5.054,17.146s65.677,12.1,84.074,32.22c12.413,13.576,37.809,118.05,37.809,118.05",
    transform: "translate(32.987 178.68)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275706",
    "data-name": "Path 275706",
    d: "M35.493,48a26.3,26.3,0,0,0-4.619,1.479c-1.568.6-3.106,1.276-4.614,2.008a91.841,91.841,0,0,0-8.625,4.871c-.084.054,0,.173.089.129,2.948-1.528,5.994-2.9,9.045-4.219q2.2-.95,4.406-1.894a46.969,46.969,0,0,0,4.451-1.968c.188-.1.084-.445-.134-.406",
    transform: "translate(69.442 189.378)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275707",
    "data-name": "Path 275707",
    d: "M26.6,45.423c-.623,2.483-1.172,4.99-1.884,7.453-.326,1.128-.648,2.28-1.073,3.373-.361.925-.91,1.983-1.983,2.191-1.236.237-1.588-.821-1.489-1.84.114-1.137.406-2.275.628-3.393.262-1.291.524-2.582.757-3.877.119-.648.242-1.3.351-1.944.03-.163.148-1.4.237-1.761.01.03.03.059.069.054l.045,0a.09.09,0,0,0,.074-.064c.01-.1.01-.119-.064-.188a.1.1,0,0,0-.114-.01c-.232.134-.252.455-.326.692-.2.628-.406,1.256-.589,1.894-.346,1.182-.682,2.374-.984,3.571s-.593,2.394-.89,3.6a5.585,5.585,0,0,0-.242,2.76,2.113,2.113,0,0,0,1.958,1.587c-.045.084-.094.158-.134.242-.109.247-.188.509-.282.757s-.178.514-.252.776a2.65,2.65,0,0,0-.074.386c-.015.143.015.287,0,.43a.208.208,0,0,0,.386.138c.064-.129.163-.227.232-.346a1.851,1.851,0,0,0,.178-.42c.084-.247.158-.495.223-.752s.138-.5.188-.757c.025-.148.03-.3.045-.455a2.883,2.883,0,0,0,1.434-.549,4.8,4.8,0,0,0,1.489-2.27c.376-1.034.663-2.107.954-3.165a46.537,46.537,0,0,0,1.588-8.007.231.231,0,0,0-.45-.1",
    transform: "translate(75.07 178.52)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275708",
    "data-name": "Path 275708",
    d: "M77.726,77.753a40.139,40.139,0,0,0-4.085-.252c-1.429-.059-2.863-.124-4.3-.168-2.824-.079-5.643-.134-8.467-.143-5.687-.02-11.37-.02-17.057.074-2.962.045-9.317.129-9.669.242a.146.146,0,0,0,.045.287c5.643.3,11.291.4,16.939.5s11.291.188,16.929.094c1.563-.03,3.126-.089,4.688-.129a48.419,48.419,0,0,0,4.941-.213c.158-.025.223-.262.035-.292",
    transform: "translate(134.31 304.512)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275709",
    "data-name": "Path 275709",
    d: "M108.772,118.706a15.028,15.028,0,0,0-2.127-4.387,7.792,7.792,0,0,0-4.174-2.146c-13.58-3.719-27.6-5.386-41.4-8a168.8,168.8,0,0,1-20.153-4.911,78.165,78.165,0,0,1-19.065-8.576,21.3,21.3,0,0,1-7.013-7.4,32.007,32.007,0,0,1-3.294-9.253,56.488,56.488,0,0,1,.049-22.369,52.929,52.929,0,0,1,1.395-5.445c.035-.114-.138-.153-.173-.044A54.389,54.389,0,0,0,9.742,68.4c.495,6.548,2.082,13.442,6.315,18.645A26.244,26.244,0,0,0,23.9,93.2a83.266,83.266,0,0,0,9.6,4.52,127.535,127.535,0,0,0,19.792,5.91c13.773,3.046,27.834,4.594,41.607,7.656q2.544.571,5.079,1.207a17.909,17.909,0,0,1,5,1.612c1.632,1.019,2.171,3.051,2.814,4.743.712,1.869,22.853,76.809,23.353,78.694.084.307.544.163.47-.139-1.934-7.661-21.4-75.019-22.844-78.7",
    transform: "translate(37.864 181.928)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275710",
    "data-name": "Path 275710",
    d: "M51.479,68.113c-.519-1.637-.969-3.393-2.493-4.387-1.414-.92-23.323-3.912-25.776-4.288-.114-.02-.158.153-.045.173,2.1.356,22.235,3.961,24.035,4.56a4,4,0,0,1,1.963,1.271,8.526,8.526,0,0,1,1.147,2.73q.935,2.93,1.86,5.851c1.241,3.912,2.483,7.829,3.665,11.765,1.335,4.456,2.868,9.13,4.021,13.64.089.341.579.178.519-.158-1.533-8.462-8.249-29.119-8.9-31.157",
    transform: "translate(91.141 234.509)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275711",
    "data-name": "Path 275711",
    d: "M19.618,48.782a183.338,183.338,0,0,1,29.743,6.1A208,208,0,0,1,78.055,65.256c5.218,2.339,10.267,4.955,15.272,7.71.1.054.01.2-.089.148A233.153,233.153,0,0,0,65.33,60.944a224.71,224.71,0,0,0-29.065-8.427C30.711,51.31,25.117,50.37,19.514,49.44c-.371-.064-.272-.7.1-.658",
    transform: "translate(76.074 192.465)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275712",
    "data-name": "Path 275712",
    d: "M22.454,50.682C27.622,62.176,47.8,99.163,60.184,101.34c8.126,1.424,40.544-3.017,45.84-10.94,2.31-3.452-2.75-26.681-7.052-25.578S68.715,70.41,65.475,69.6s-28.358-27.5-37.6-34.011c-15.944-11.221-8.2,8.9-5.42,15.089",
    transform: "translate(71.472 127.247)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275713",
    "data-name": "Path 275713",
    d: "M91.331,65.136l2.087,35.118s-25.6,5.732-36.8,1.909c-13.6-4.639-33.63-46.622-36.375-53.521-4.51-11.335-3.3-18.21,3.037-16.553,2.463.623,5.707,2.547,9.683,6.024,4.159,3.625,28.071,27.136,35.608,31.567,4.214,2.478,22.759-4.545,22.759-4.545",
    transform: "translate(69.202 125.642)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87459",
    "data-name": "Group 87459",
    transform: "translate(86.741 157.485)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87458",
    "data-name": "Group 87458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87457",
    "data-name": "Group 87457",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275714",
    "data-name": "Path 275714",
    d: "M91.331,65.136l2.087,35.118s-25.6,5.732-36.8,1.909c-13.6-4.639-33.63-46.622-36.375-53.521-4.51-11.335-3.3-18.21,3.037-16.553,2.463.623,5.707,2.547,9.683,6.024,4.159,3.625,28.071,27.136,35.608,31.567,4.214,2.478,22.759-4.545,22.759-4.545",
    transform: "translate(-17.539 -31.843)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275715",
    "data-name": "Path 275715",
    d: "M32.766,70.431c-.465-5.183-1.588-26.449-1.523-31.063,0-.317.213-.391.247-.059,1.766,15.489,1.286,25.994,1.479,31.1,0,.129-.193.158-.2.025",
    transform: "translate(123.261 154.239)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87462",
    "data-name": "Group 87462",
    transform: "translate(86.741 157.487)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87461",
    "data-name": "Group 87461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87460",
    "data-name": "Group 87460",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275716",
    "data-name": "Path 275716",
    d: "M82.557,102.2c-8.353,1.207-19.52,2.156-25.944-.035-13.6-4.639-33.62-46.617-36.365-53.521-4.515-11.335-3.3-18.2,3.032-16.553.2.049.4.109.6.178Z",
    transform: "translate(-17.538 -31.844)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275717",
    "data-name": "Path 275717",
    d: "M76.661,110.665c-1.543,1.5-67.586,8.373-67.912,7.928-.875-1.2,11.464-63.17,37.913-84.525,4.659-3.764,12.433-2.181,15.949.079,1.761,1.133,6.627,10.03,8.027,17.942s6.993,57.621,6.024,58.575",
    transform: "translate(34.347 125.494)",
    fill: "#ffe7ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275718",
    "data-name": "Path 275718",
    d: "M50.575,31.952s7.206,37.443,7.438,38.971-.816,43.219-.816,43.219L8.152,120.2S13.7,99.5,13.993,98.5,24.67,63.154,35.837,47.753C46.1,33.6,50.575,31.952,50.575,31.952",
    transform: "translate(32.164 126.066)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87465",
    "data-name": "Group 87465",
    transform: "translate(40.321 158.018)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87464",
    "data-name": "Group 87464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87463",
    "data-name": "Group 87463",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275719",
    "data-name": "Path 275719",
    d: "M50.575,31.952s7.206,37.443,7.438,38.971-.816,43.219-.816,43.219L8.152,120.2S13.7,99.5,13.993,98.5,24.67,63.154,35.837,47.753C46.1,33.6,50.575,31.952,50.575,31.952",
    transform: "translate(-8.156 -31.952)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275720",
    "data-name": "Path 275720",
    d: "M19.81,32.392S24.761,65.611,24.9,67.708s3.882,42.5,3.882,42.5l6.053-2.27s-3.378-26.3-3.773-28.58-3.215-26.741-4.273-31.315c-1.677-7.235-6.983-15.653-6.983-15.653",
    transform: "translate(78.161 127.802)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87468",
    "data-name": "Group 87468",
    transform: "translate(97.973 160.193)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87467",
    "data-name": "Group 87467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87466",
    "data-name": "Group 87466",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275721",
    "data-name": "Path 275721",
    d: "M19.81,32.392S24.761,65.611,24.9,67.708s3.882,42.5,3.882,42.5l6.053-2.27s-3.378-26.3-3.773-28.58-3.215-26.741-4.273-31.315c-1.677-7.235-6.983-15.653-6.983-15.653",
    transform: "translate(-19.812 -32.39)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275722",
    "data-name": "Path 275722",
    d: "M64.4,88.759l-40.7,4.154L37.382,38.765l40.7-4.154Z",
    transform: "translate(93.538 136.555)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275723",
    "data-name": "Path 275723",
    d: "M52.851,36.543c2.29,4.352,7.819,9.649,8.4,13.254a4.2,4.2,0,0,1-2.146,4.52s3.689,1.657,3.679,5.015c0,1.731-2.774,3.244-2.774,3.244s2.9,1.454,2.71,4.441c-.158,2.384-2.908,3.541-2.908,3.541s2.132,2.69,1.2,5.069c-1.894,4.817-22.359,5.653-25.831-1.756-1.617-3.457,3.393-3.388,3.393-3.388S31.4,68.65,31.116,64.431,37.337,60.7,37.337,60.7s-6.944-1.84-6.79-6.236c.153-4.58,6.578-2.987,6.578-2.987s-4.678-2.9-3.788-6.236c1.459-5.519,10.356.979,14.812-.272l2.176-7.517Z",
    transform: "translate(120.515 144.18)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275724",
    "data-name": "Path 275724",
    d: "M41.434,51.093c-1.805-4.308,3.393-9.936,2.255-14.3-1.533-5.915-8.007.208-9.144,8.932l.307,6.924Z",
    transform: "translate(136.299 135.906)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275725",
    "data-name": "Path 275725",
    d: "M53.334,44.04a.053.053,0,0,1,.025.1,35.523,35.523,0,0,1-21.132-.4c-.213-.074-.183-.46.069-.42a72.834,72.834,0,0,0,21.038.712",
    transform: "translate(126.591 170.941)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275726",
    "data-name": "Path 275726",
    d: "M55.068,43.5c.079-.01.1.124.015.143C48.2,45.577,39.3,45.4,32.056,41.774c-.247-.124-.346-.485-.049-.361C37,43.456,48.5,44.326,55.068,43.5",
    transform: "translate(125.563 163.296)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275727",
    "data-name": "Path 275727",
    d: "M31.92,39.485c7.077,3.2,14.466,3.823,22.151,3.363.1,0,.1.138.015.168-3.7,1.246-8.625,1.029-12.443.534a20.5,20.5,0,0,1-9.837-3.818c-.114-.084-.04-.317.114-.247",
    transform: "translate(125.275 155.739)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275728",
    "data-name": "Path 275728",
    d: "M41.134,42.81C21.451,65.035-.607,102.389,9.092,110.208c8.862,7.141,40.85-.1,60.919-8.21,3.818-1.543-5.059-35.653-9.3-34.475-7.324,2.038-18.887,6.968-19.4,7.112-1.1.317,4.189-12.947,10.682-29.025,7.25-17.933.4-15.5-10.855-2.8",
    transform: "translate(26.556 129.096)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275729",
    "data-name": "Path 275729",
    d: "M61.6,46.361a5.193,5.193,0,0,1-2.72,4.11,7.3,7.3,0,0,1,2.671,4.169c.519,2.952-3.882,5.069-3.882,5.069a8.955,8.955,0,0,1,2.117,4.847C60,67.434,55.864,70.2,55.864,70.2a7.872,7.872,0,0,1-.826,5.43c-2.631,4.317-28.1,7.621-31.548,7.923L17.358,48.008S39.029,37.177,44.816,37.875c4.876.584,17.25,3.249,16.785,8.487",
    transform: "translate(68.487 149.308)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275730",
    "data-name": "Path 275730",
    d: "M38.415,42.85c-5.035-1.869-10.5-2.527-15.791-3.106a.092.092,0,0,0-.02.183c5.267.514,10.519,2.448,15.752,3.17a.129.129,0,0,0,.059-.247",
    transform: "translate(88.879 156.81)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275731",
    "data-name": "Path 275731",
    d: "M37.776,42.728a14,14,0,0,0-3.63-.465q-1.944-.119-3.887-.163c-2.6-.069-5.193-.079-7.789-.01-.114,0-.138.178-.02.183,2.587.074,5.173.183,7.755.366,1.291.089,2.587.188,3.877.3a16.791,16.791,0,0,0,3.66.138.184.184,0,0,0,.035-.351",
    transform: "translate(88.267 165.879)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275732",
    "data-name": "Path 275732",
    d: "M36.32,44.771a9.775,9.775,0,0,0-3.289-.247q-1.78-.007-3.551-.035c-2.369-.04-4.733-.079-7.1-.2-.119,0-.138.178-.02.183,2.4.138,4.8.307,7.206.42,1.177.054,2.359.1,3.536.148a9.248,9.248,0,0,0,3.22-.148.066.066,0,0,0,0-.119",
    transform: "translate(87.922 174.731)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275733",
    "data-name": "Path 275733",
    d: "M51.706,33.578C37.388,42.415.554,94.4,7.334,108.711S60.3,107.262,60.3,107.262L56.211,68.419s-12.146,6.835-12.552,6.217,6.672-18.353,9.555-25.569,6.113-20.193-1.508-15.489",
    transform: "translate(25.683 128.526)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87471",
    "data-name": "Group 87471",
    transform: "translate(32.192 161.101)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87470",
    "data-name": "Group 87470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87469",
    "data-name": "Group 87469",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275734",
    "data-name": "Path 275734",
    d: "M51.706,33.578C37.388,42.415.554,94.4,7.334,108.711S60.3,107.262,60.3,107.262L56.211,68.419s-12.146,6.835-12.552,6.217,6.672-18.353,9.555-25.569,6.113-20.193-1.508-15.489",
    transform: "translate(-6.509 -32.575)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275735",
    "data-name": "Path 275735",
    d: "M19.289,72.079c-.856-5.129-3.586-26.251-3.867-30.855-.02-.321.178-.41.242-.079,2.928,15.311,3.244,25.821,3.828,30.895.015.124-.183.168-.2.04",
    transform: "translate(60.839 161.512)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275736",
    "data-name": "Path 275736",
    d: "M39.6,39.842a28.077,28.077,0,0,0-3.9,1.8c-1.142.569-2.285,1.142-3.417,1.731-2.463,1.281-4.9,2.611-7.319,3.966s-4.827,2.73-7.211,4.144-4.683,2.957-7.062,4.377c-.114.064,0,.223.109.163,2.423-1.38,4.936-2.591,7.389-3.907L25.4,48.24c2.4-1.286,4.812-2.557,7.211-3.853,1.177-.633,2.344-1.276,3.516-1.914a30.8,30.8,0,0,0,3.719-2.151.272.272,0,0,0-.242-.48",
    transform: "translate(42.002 157.142)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275737",
    "data-name": "Path 275737",
    d: "M22.777,40.4c-.747.954-1.479,1.909-2.176,2.9-.124.183-.242.371-.366.559.188-.509.376-1.019.569-1.528a52.982,52.982,0,0,0,1.924-5.391.077.077,0,0,0-.143-.049,53.793,53.793,0,0,0-2.428,5.46c-.762,1.79-1.538,3.576-2.26,5.376s-1.479,3.605-2.166,5.42a38.725,38.725,0,0,0-1.85,5.44c-.025.1.129.148.183.059a41.407,41.407,0,0,0,2.5-5.425c.747-1.8,1.444-3.615,2.166-5.42.3-.757.589-1.518.875-2.285.129-.173.252-.346.376-.514.346-.47.673-.964.989-1.459.653-1.019,1.261-2.057,1.864-3.106.015-.035-.035-.069-.059-.04",
    transform: "translate(54.754 145.423)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275738",
    "data-name": "Path 275738",
    d: "M46.314,47.68c-.025-.257-.158-.312-.2-.035-.025.153-.045.43-.069.584-1.578.42-7.324,2.176-8.729,2.6q-4.421,1.306-8.917,2.3-4.518,1-9.08,1.716c-3.027.475-6.1.969-9.154,1.167a.1.1,0,0,0,.01.193c3.126-.163,6.222-.252,9.332-.608,3.042-.351,6.073-.861,9.07-1.489,3.051-.638,6.083-1.419,9.065-2.329,1.489-.455,2.972-.95,4.441-1.469a22.466,22.466,0,0,0,4.154-1.677.328.328,0,0,0,.143-.292c-.02-.223-.045-.44-.064-.663",
    transform: "translate(39.748 187.257)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275739",
    "data-name": "Path 275739",
    d: "M29.335,54.819c-3.808.831-10.222-5.064-12.715-9.8C16.452,44.69,18,31.847,18.049,29.27c0-.529,16.118,4.2,16.118,4.2a41.1,41.1,0,0,0-1.731,9.871c0,.376.579,10.673-3.1,11.479",
    transform: "translate(65.526 115.321)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275740",
    "data-name": "Path 275740",
    d: "M32.624,33.432l-.01.01c-.025.079-.119.4-.257.9-.237.861-.6,2.265-.9,3.867a29.257,29.257,0,0,0-.569,5.094c-.01.119,0,.242,0,.356v.054c.015.213.02.495.02.826a9.986,9.986,0,0,1-1.573.064C20.537,44.258,17.753,33.4,17,29.238c.094.01.183.03.282.049.425.074.984.2,1.657.361.168.045.336.089.519.129,1.073.267,2.354.613,3.689.964.435.119.875.237,1.32.366.954.272,1.919.539,2.814.786.386.119.767.227,1.123.321.4.109.786.227,1.147.321.178.054.356.109.524.153.089.03.168.054.247.074l1.335.386c.267.079.48.143.638.183.134.045.228.064.272.089l.045.01Z",
    transform: "translate(67.078 115.358)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275741",
    "data-name": "Path 275741",
    d: "M17.521,31.83c-2.23,5.564-.623,22.319,3.131,26.34,5.445,5.836,15.054,7.166,20.2.475,4.98-6.489,2.493-28.284-1.766-32.013-6.271-5.495-18.264-3.017-21.563,5.2",
    transform: "translate(65.114 93.483)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275742",
    "data-name": "Path 275742",
    d: "M20.514,27.577c-.015-.04-.084.064-.074.109.173,1.123.178,2.438-.8,2.933-.03.015-.02.074.015.064,1.227-.326,1.2-2.072.856-3.106",
    transform: "translate(77.437 108.77)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275743",
    "data-name": "Path 275743",
    d: "M20.569,27.358c-1.83.079-1.533,3.729.158,3.655,1.672-.069,1.375-3.724-.158-3.655",
    transform: "translate(76.236 107.936)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275744",
    "data-name": "Path 275744",
    d: "M21.153,27.511c0-.045.094.045.094.094.054,1.133.312,2.423,1.365,2.715.03.01.035.064,0,.064-1.261-.074-1.583-1.79-1.454-2.873",
    transform: "translate(83.357 108.495)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275745",
    "data-name": "Path 275745",
    d: "M22.059,27.259c1.81-.287,2.245,3.353.569,3.615-1.647.262-2.082-3.378-.569-3.615",
    transform: "translate(83.365 107.486)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275746",
    "data-name": "Path 275746",
    d: "M20.136,29.209a14.2,14.2,0,0,0,1.375-.613,2.409,2.409,0,0,0,1.281-.89.781.781,0,0,0-.2-.925,1.92,1.92,0,0,0-1.949-.04,2.824,2.824,0,0,0-1.523,1.345.828.828,0,0,0,1.014,1.123",
    transform: "translate(75.091 104.532)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275747",
    "data-name": "Path 275747",
    d: "M24.06,28.7a13.678,13.678,0,0,1-1.484-.257,2.46,2.46,0,0,1-1.459-.554.779.779,0,0,1-.03-.945,1.909,1.909,0,0,1,1.874-.514,2.825,2.825,0,0,1,1.805.935A.826.826,0,0,1,24.06,28.7",
    transform: "translate(82.631 104.096)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275748",
    "data-name": "Path 275748",
    d: "M19.852,29.722c.292.242.593.584,1,.589a2.941,2.941,0,0,0,1.192-.386c.035-.015.074.02.054.054a1.524,1.524,0,0,1-1.385.732,1.21,1.21,0,0,1-.969-.93c-.025-.064.059-.094.1-.059",
    transform: "translate(77.901 117.209)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275749",
    "data-name": "Path 275749",
    d: "M19.974,39.114a3.862,3.862,0,0,0,2.71,1.5,4.86,4.86,0,0,0,1.39-.045,1.541,1.541,0,0,0,.262-.054,1.72,1.72,0,0,0,.242-.059.28.28,0,0,0,.208-.267v-.01l-.02-.114v-.01l-.01-.1c-.049-.875-.242-2.191-.242-2.191.331.134,2.013.732,1.953.282a57.918,57.918,0,0,0-2.438-11.533.1.1,0,0,0-.2.045c.366,3.62,1.365,7.156,1.79,10.786a6.862,6.862,0,0,0-1.86-.406c-.124.045.415,2.542.406,2.933l0,.045a5.354,5.354,0,0,1-4.085-.915c-.089-.059-.173.025-.1.109",
    transform: "translate(78.695 104.335)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275750",
    "data-name": "Path 275750",
    d: "M23.778,30.088a4.651,4.651,0,0,1-1.716,1.568,2.116,2.116,0,0,1-1.246.178c-.915-.168-1-.994-.9-1.716A5.061,5.061,0,0,1,20.232,29a5.946,5.946,0,0,0,3.546,1.088",
    transform: "translate(78.442 114.419)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275751",
    "data-name": "Path 275751",
    d: "M22.063,30.759a2.026,2.026,0,0,1-1.241.178c-.925-.163-1.014-.989-.905-1.711a2.125,2.125,0,0,1,2.146,1.533",
    transform: "translate(78.44 115.311)",
    fill: "#ffe7cd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87474",
    "data-name": "Group 87474",
    transform: "translate(93.672 126.722)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87473",
    "data-name": "Group 87473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87472",
    "data-name": "Group 87472",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275752",
    "data-name": "Path 275752",
    d: "M25.312,26.161a13.72,13.72,0,0,0,1.86.059c.628-.049,1.241-.223,1.869-.252a10.038,10.038,0,0,1,3.5.6c.1.03.084.094-.015.069a8.792,8.792,0,0,0-3.7-.356,11.04,11.04,0,0,1-3.071.183,11.051,11.051,0,0,0-6.8.989l-.015-.02a11.147,11.147,0,0,1,6.37-1.276",
    transform: "translate(-18.935 -24.305)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275753",
    "data-name": "Path 275753",
    d: "M25.026,25.816a13.138,13.138,0,0,0,1.766.054c.593-.044,1.172-.208,1.771-.237a9.455,9.455,0,0,1,3.318.574c.094.025.079.089-.015.064a8.286,8.286,0,0,0-3.511-.336,10.626,10.626,0,0,1-2.908.173A10.526,10.526,0,0,0,19,27.043l-.01-.02a10.556,10.556,0,0,1,6.039-1.207",
    transform: "translate(-18.758 -25.622)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275754",
    "data-name": "Path 275754",
    d: "M44.031,37.9c-5.732,4.016-13.7-1.879-13.7-1.879A6.277,6.277,0,0,1,24,40.06s-1.029,9.772-3.605,9.782c-3.927.02-5.282-13.279-4.07-15.91S20.861,30.6,20.861,30.6a6.412,6.412,0,0,1,2.626-3.912c2.661-2.077,11.944.584,11.944.584a8.6,8.6,0,0,1,2.339-3.22,2.427,2.427,0,0,1,3.5.282,5.83,5.83,0,0,0-.915,2.418c-.435,2.863,1.9,2.834,1.855.242a4.026,4.026,0,0,0-.94-2.661c1.137-1.706,3.017-2.275,4.169-1.38,2.092,1.622,3.363,11.617-1.4,14.95",
    transform: "translate(62.724 88.903)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275755",
    "data-name": "Path 275755",
    d: "M23.355,37.359a5.273,5.273,0,1,1,1.3-.109,5.266,5.266,0,0,1-1.3.109m.44-9.8a4.607,4.607,0,0,0-1.128.089,4.556,4.556,0,1,0,1.128-.089",
    transform: "translate(72.337 105.931)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275756",
    "data-name": "Path 275756",
    d: "M24.936,37.161C22.928,37.067,21.2,34.931,21,32.2a6.246,6.246,0,0,1,.846-3.744,3.272,3.272,0,0,1,5.588-.406,6.274,6.274,0,0,1,1.37,3.586c.208,2.888-1.375,5.366-3.521,5.524-.119,0-.232.01-.346,0m-.094-9.792a1.608,1.608,0,0,0-.267,0,2.8,2.8,0,0,0-2.136,1.449,5.573,5.573,0,0,0-.737,3.318c.178,2.507,1.756,4.441,3.526,4.313s3.056-2.265,2.878-4.772a5.55,5.55,0,0,0-1.212-3.18,2.878,2.878,0,0,0-2.052-1.133",
    transform: "translate(82.779 105.2)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275757",
    "data-name": "Path 275757",
    d: "M20.8,29.09l-.49-.5c.747-.727,2.522-1.756,3.9-.48l-.48.519c-1.231-1.147-2.863.4-2.933.465",
    transform: "translate(80.138 108.504)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275758",
    "data-name": "Path 275758",
    d: "M16.224,31.458l-.648-.277c.134-.3,1.311-2.952,2.854-3.318,1.449-.341,10.9-.134,11.306-.124l-.015.7c-2.71-.064-10.01-.158-11.128.1-1.019.242-2.057,2.186-2.369,2.913",
    transform: "translate(61.456 109.162)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275759",
    "data-name": "Path 275759",
    d: "M22.8,31.766s-3.393-5.584-5.91-4.411-.2,9.1,2.577,10.346a2.9,2.9,0,0,0,3.986-1.3Z",
    transform: "translate(62.38 107.291)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275760",
    "data-name": "Path 275760",
    d: "M16.212,27.682a.039.039,0,0,0-.025.074c1.949.94,2.878,2.859,3.487,4.827a1.6,1.6,0,0,0-2.364-.593c-.054.035-.01.119.049.109a1.783,1.783,0,0,1,1.919.747,8.451,8.451,0,0,1,.836,1.647c.084.188.41.114.356-.1l-.01-.044c.213-2.542-1.533-6.231-4.248-6.667",
    transform: "translate(63.778 109.219)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275761",
    "data-name": "Path 275761",
    d: "M35.151,34.4l-3.867,9.619L19.33,31.839l-3.388,3.907S27.633,55.088,27.707,54.218l3.966-8.294L37.4,51.7l-.46-14.486Z",
    transform: "translate(62.9 125.621)",
    fill: "#ffe7ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275762",
    "data-name": "Path 275762",
    d: "M37.188,40.692c-.158-2.389-.247-4.8-.514-7.181-.01-.084-.138-.119-.163-.02-.48,2.3.168,11.439.158,13.63l-.025-.025c-.237-.252-5.307-5.079-5.356-5-.861,1.32-3.773,7.359-3.971,7.908-1.85-3.076-8.937-14.243-11.123-17.151a.083.083,0,0,0-.143.084C17.683,36.176,27.06,51.221,27.2,51.176a91.85,91.85,0,0,0,4.149-8.768c.861,1.053,5.969,6.5,5.989,6.147a74.489,74.489,0,0,0-.153-7.863",
    transform: "translate(63.286 129.453)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25345",
    "data-name": "Rectangle 25345",
    width: 78.283,
    height: 175.162,
    transform: "translate(251.017 241.254)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87477",
    "data-name": "Group 87477",
    transform: "translate(251.017 241.256)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87476",
    "data-name": "Group 87476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87475",
    "data-name": "Group 87475",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25346",
    "data-name": "Rectangle 25346",
    width: 78.283,
    height: 175.162,
    transform: "translate(0 -0.001)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25348",
    "data-name": "Rectangle 25348",
    width: 78.283,
    height: 175.162,
    transform: "translate(29.698 241.254)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25349",
    "data-name": "Rectangle 25349",
    width: 221.319,
    height: 24.332,
    transform: "translate(107.981 241.259)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87480",
    "data-name": "Group 87480",
    transform: "translate(107.985 241.256)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87479",
    "data-name": "Group 87479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87478",
    "data-name": "Group 87478",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25350",
    "data-name": "Rectangle 25350",
    width: 221.319,
    height: 24.332,
    transform: "translate(-0.004 0.003)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87483",
    "data-name": "Group 87483",
    transform: "translate(108.486 253.12)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87482",
    "data-name": "Group 87482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87481",
    "data-name": "Group 87481",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275763",
    "data-name": "Path 275763",
    d: "M21.936,51.479c55.039-.4,165.79-.4,220.814,0-55.034.4-165.79.4-220.814,0",
    transform: "translate(-21.936 -51.181)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25353",
    "data-name": "Rectangle 25353",
    width: 10.534,
    height: 175.162,
    transform: "translate(107.986 241.254)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87486",
    "data-name": "Group 87486",
    transform: "translate(107.987 241.256)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87485",
    "data-name": "Group 87485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87484",
    "data-name": "Group 87484",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25354",
    "data-name": "Rectangle 25354",
    width: 10.534,
    height: 175.162,
    transform: "translate(-0.001 -0.001)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25356",
    "data-name": "Rectangle 25356",
    width: 10.534,
    height: 175.162,
    transform: "translate(318.771 241.254)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87489",
    "data-name": "Group 87489",
    transform: "translate(318.77 241.256)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87488",
    "data-name": "Group 87488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87487",
    "data-name": "Group 87487",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25357",
    "data-name": "Rectangle 25357",
    width: 10.534,
    height: 175.162,
    transform: "translate(0.001 -0.001)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25359",
    "data-name": "Rectangle 25359",
    width: 64.07,
    height: 2.873,
    transform: "translate(147.941 238.381)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25360",
    "data-name": "Rectangle 25360",
    width: 32.245,
    height: 2.873,
    transform: "translate(179.761 238.381)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275764",
    "data-name": "Path 275764",
    d: "M37.05,82.615H99.487l8.165-42.408H45.215Z",
    transform: "translate(146.181 158.638)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275765",
    "data-name": "Path 275765",
    d: "M43.431,47.529a3.427,3.427,0,0,0,3.467,3.8,4.229,4.229,0,0,0,4.135-3.8,3.431,3.431,0,0,0-3.467-3.8,4.234,4.234,0,0,0-4.135,3.8",
    transform: "translate(171.3 172.521)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275766",
    "data-name": "Path 275766",
    d: "M92.989,59.022,90.472,74.116,73.424,166.187h-2.75l12.4-92.071L84.9,59.022Z",
    transform: "translate(278.851 232.872)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275767",
    "data-name": "Path 275767",
    d: "M75.012,59.022H83.1L80.581,74.116h-7.4Z",
    transform: "translate(288.744 232.872)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275768",
    "data-name": "Path 275768",
    d: "M103.815,166.187h-2.75L84.018,74.116,81.5,59.022h8.086l1.83,15.094Z",
    transform: "translate(321.565 232.872)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275769",
    "data-name": "Path 275769",
    d: "M89.586,59.022l1.83,15.094h-7.4L81.5,59.022Z",
    transform: "translate(321.564 232.872)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275770",
    "data-name": "Path 275770",
    d: "M114.155,166.187h-2.75L94.358,74.116,91.841,59.022h8.086l1.83,15.094Z",
    transform: "translate(362.364 232.872)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275771",
    "data-name": "Path 275771",
    d: "M101.757,74.116h-7.4L91.841,59.022h8.086Z",
    transform: "translate(362.364 232.872)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275772",
    "data-name": "Path 275772",
    d: "M195.14,143.916H70.211V130.751h46.765L132.693,39.3h57.685Z",
    transform: "translate(277.02 155.07)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275773",
    "data-name": "Path 275773",
    d: "M104.448,143.916h-6.81L93.2,39.3h6.489Z",
    transform: "translate(367.713 155.07)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275774",
    "data-name": "Path 275774",
    d: "M55.466,129.4c2.31,1.35,73.348,16.2,76.414,15.054,1.167-.43,3.932-10.648,6.924-23.091.648-2.69,1.3-5.47,1.944-8.294,4.209-18.338,8.249-37.9,8.249-37.9L101.5,65.1l-6.944,38.18-1.528,8.378s-29.743,6.479-32.972,8.1-6.9,8.3-4.594,9.649",
    transform: "translate(215.995 256.858)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275775",
    "data-name": "Path 275775",
    d: "M137.65,87.2c-2.527,10.2-4.758,17.967-5.771,18.348-3.061,1.147-74.109-13.714-76.414-15.064s1.38-8.017,4.589-9.644c1.993-.994,14.08-3.843,23.046-5.88-7.829,1.869-22.443,7.181,7.774,9.367,24.985,1.815,41.473,2.641,46.775,2.873",
    transform: "translate(215.997 295.765)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275776",
    "data-name": "Path 275776",
    d: "M68.835,145.729c2.577.717,75.054-3.027,77.724-4.916,1.019-.712-1.77-29.812-2.527-32.606-2.572-9.481-14.822-38.036-14.822-38.036L80.724,72.535,100.635,119S73.529,132.841,70.818,135.23s-4.56,9.782-1.983,10.5",
    transform: "translate(266.741 276.862)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275777",
    "data-name": "Path 275777",
    d: "M146.562,98.256c-2.676,1.894-75.143,5.638-77.729,4.926s-.712-8.121,1.983-10.5c1.271-1.118,7.819-4.7,14.461-8.224-8.333,4.693-21.523,15.153,60.529-3.5.747,8.3,1.3,16.919.757,17.3",
    transform: "translate(266.738 319.415)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275778",
    "data-name": "Path 275778",
    d: "M187.321,92.362c-14.446,16.093-62.982,3.383-65.885,9.787-2.552,5.648,30.568,96.344,30.568,96.344l-53,5.712S53.252,104.038,69.6,75.1c8.838-15.633,47.759-9.4,71.251-12.26,7.087-.865,10.415-15.475,10.415-15.475h41.973s10.593,26.6-5.92,44.995",
    transform: "translate(260.692 186.887)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275779",
    "data-name": "Path 275779",
    d: "M69.766,66.13l44.505,34.06c14.782-.316,47.136,4.807,58.476-7.834,16.513-18.393,5.925-44.99,5.925-44.99H136.694s-3.328,14.609-10.41,15.475c-16.488,2-40.559-.465-56.518,3.289",
    transform: "translate(275.266 186.887)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275780",
    "data-name": "Path 275780",
    d: "M72.4,80.477c1.464-.46,15.208-1.993,18.239-2.32,6.063-.653,25.168-2.438,28.625-2.428a.083.083,0,0,1,.02.163c-3.007.628-15.2,2.052-18.229,2.364-6.073.623-26.943,2.646-28.63,2.478a.131.131,0,0,1-.025-.257",
    transform: "translate(285.269 298.791)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275781",
    "data-name": "Path 275781",
    d: "M76.154,94.293c3.407-1.7,29.238-.856,47.774-2.591,6.043-.569,12.1-1.855,16.711-5.811a27.625,27.625,0,0,0,8.249-13.59c1.78-6.33,1.6-12.938,1.291-19.426-.074-1.6-.183-3.19-.282-4.787-.01-.089.158-.109.168-.015,1.409,11.617,2.488,24.6-5.069,34.673a24.32,24.32,0,0,1-13.511,8.862c-11.182,2.938-53.209,2.211-54.693,3.343C75.026,96.3,102.2,179.031,102.736,180.6c.1.3-.415.5-.544.2-2.68-6.345-29.006-85.039-26.038-86.513",
    transform: "translate(299.55 189.426)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275782",
    "data-name": "Path 275782",
    d: "M68.214,62.96c2.5-6.345,8.2-10.292,16.582-11.805.143-.025.133.183,0,.223-7.314,2.136-12.547,5.079-15.425,11.256-1.34,2.883-2.038,6.934-2.384,12.364-1.741,27.087,21.894,88.575,22.374,89.643a.082.082,0,0,1-.143.079c-3.328-5.608-31.315-75.578-21-101.76",
    transform: "translate(260.181 201.823)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275783",
    "data-name": "Path 275783",
    d: "M62.528,172.558l40.133,8.536S71,86.594,85.871,74.4c4.12-3.378,13.106-4.56,23.788.054,15.944,6.884,34.4,20.93,51.8,26.063,16.3,4.812,35.643.386,42.3-6.944,13.986-15.391,3.467-44.485,3.467-44.485L149.51,46.926s.861.7-1.894,3.14c0,0-33.927-7.69-48.664,1.316C72.365,67.628,62.528,172.558,62.528,172.558",
    transform: "translate(246.708 185.147)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275784",
    "data-name": "Path 275784",
    d: "M87.252,48.1a.1.1,0,0,1,.2.035,32.219,32.219,0,0,0,.5,6.469,11.152,11.152,0,0,0,2.9,5.376c3.16,3.2,7.7,4.293,11.85,5.6.218.069.178.455-.064.42-4.6-.707-9.446-1.874-12.809-5.326a11.218,11.218,0,0,1-2.977-5.8,13.861,13.861,0,0,1,.4-6.775",
    transform: "translate(341.746 189.511)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275785",
    "data-name": "Path 275785",
    d: "M72.405,53.638c6.172-3.872,15.816-.93,20.435.841.094.035.049.193-.049.153-4.248-1.528-14.817-3.838-20.47.163-13.056,9.253,4.421,72.517,15.88,107.333.178.544-.252.4-.495-.124-1.889-4.125-16.662-48.125-20.514-77.23C66.6,80.3,63.508,59.221,72.405,53.638",
    transform: "translate(261.168 204.113)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275786",
    "data-name": "Path 275786",
    d: "M63.553,70.171c1.212-.03,11.612,2.26,13.9,2.779,4.585,1.029,15.208,3.778,17.685,4.728.064.025.025.163-.044.153-2.384-.227-7.918-1.439-10.2-1.968-4.58-1.063-20.267-4.832-21.414-5.445-.1-.054-.044-.242.074-.247",
    transform: "translate(250.257 276.861)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275787",
    "data-name": "Path 275787",
    d: "M67.865,67.648c4.154-2.27,9.095-2.641,13.7-2.072a47.887,47.887,0,0,1,14,4.382c9.387,4.293,18.333,9.535,27.73,13.8,9.347,4.248,19.327,7.572,29.624,7.888,8.808.267,19.95-1.281,25.613-9.2,8.719-12.2,3.64-33.244,3.536-34.6,0-.109.138-.1.163,0,6.765,25.865-1.939,35.9-7.814,40.128-4.669,3.353-11.375,4.2-15.8,4.575-10.247.865-20.519-1.647-30.015-5.425-9.733-3.877-18.862-9.1-28.185-13.867C91.475,68.681,81.51,63.963,71.3,66.584a25.02,25.02,0,0,0-3.4,1.162c-.054.02-.089-.069-.04-.1",
    transform: "translate(267.671 188.461)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275788",
    "data-name": "Path 275788",
    d: "M80.2,71.214c-.153,12.977-.089,26.325,1.751,39.189,1.434,10.015,6.024,18.116,16.587,20.133,9.8,1.86,23.61,1.083,31.538-5.707,3.689-3.165,4.837-7.453,4.372-12.181-.638-6.578-7.438-42.448-9.491-53.635-1.236-6.815-2.458-13.729-4.9-20.257-5.119-13.7-11.993-13.289-12.957-13.526-.846-.495-6.231-2.616-13.635.1a14.678,14.678,0,0,0-8.581,8.338c-4.911,11.39-4.535,25.39-4.683,37.542",
    transform: "translate(316.241 94.594)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275789",
    "data-name": "Path 275789",
    d: "M86.124,24.6c8.442,3.506,10.806,12.453,13.165,20.46,3.279,11.147,6.37,22.354,8.917,33.694,1.222,5.455,2.324,10.935,3.259,16.444.9,5.272,2.181,10.885,2.057,16.256-.2,8.882-8.131,13.269-15.925,14.871a.3.3,0,0,1-.143-.589c4.436-1.078,8.947-2.522,12.127-5.984,4.085-4.441,3.348-9.97,2.6-15.48-1.271-9.372-3.071-18.665-5.208-27.878s-4.6-18.373-7.211-27.473C97.287,40.261,95.259,28.8,86.08,24.747c-.084-.04-.045-.178.044-.143",
    transform: "translate(339.451 97.05)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275790",
    "data-name": "Path 275790",
    d: "M82.656,40.538C83.932,33.7,87.162,26.953,94.2,24.673l0,.025c-9.08,3.333-10.885,13.5-11.746,21.958Q81.1,60.016,80.737,73.441c-.237,8.605-.3,17.275.247,25.87.584,9.278,2.646,17.9,8.462,25.311.119.153-.084.356-.223.213-5.673-5.954-7.834-14.406-8.615-22.369-1.029-10.49-.816-21.212-.45-31.731.346-9.995.658-20.346,2.5-30.2",
    transform: "translate(315.08 97.347)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275791",
    "data-name": "Path 275791",
    d: "M149.423,49.747c-12.774,15.7-30.247,30.539-37.562,30.3-5.9-.193-41.251-21.4-43.743-24.619-2.141-2.77,14.481-24.2,17.923-22.72,5.781,2.473,26.325,19.466,28.076,19.2,1.815-.277,16.147-6.533,30.465-13.274,13.7-6.449,13.714.208,4.842,11.113",
    transform: "translate(268.016 128.746)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275792",
    "data-name": "Path 275792",
    d: "M90.261,71.924c-2.839-1.6-15.193-10.074-18.106-13.2S61.522,45.989,63.689,43.517s4.659.158,4.659.158-2.621-4.57-.213-6.859,6.142,1.929,6.142,1.929-2.344-4.891.223-7,5.608,2.76,5.608,2.76-2.354-4.372.495-5.223c3.422-1.024,6.855,7.532,10.326,10.742.786.732,17.037,13.645,17.037,13.645Z",
    transform: "translate(249.796 115.184)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275793",
    "data-name": "Path 275793",
    d: "M66.911,30.334c2.537,6.286,4.733,8.6,10.148,12.492.109.074.02.247-.1.178-5.653-3.333-8.823-5.831-10.361-12.562-.074-.331.193-.41.312-.109",
    transform: "translate(262.72 118.941)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275794",
    "data-name": "Path 275794",
    d: "M65.743,31.136c3.2,6.3,5.569,8.823,10.94,13.323.074.064-.025.2-.109.138-5.638-3.971-8.744-6.538-11.123-13.249-.109-.307.143-.5.292-.213",
    transform: "translate(258.137 122.293)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275795",
    "data-name": "Path 275795",
    d: "M64.583,32.35C68.129,38.221,70.6,41.1,76.374,44.8a.125.125,0,0,1-.124.218c-6.256-3.195-9.367-6.77-11.835-12.542-.168-.4-.054-.5.168-.129",
    transform: "translate(253.836 126.731)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275796",
    "data-name": "Path 275796",
    d: "M90.579,51.676s-2.735-8.041-4.713-11.306S72.028,27.646,69.837,30.089c-2.824,3.16,2.948,9.965,6.207,12.933,0,0-6.543,7.3-3.457,13.081s17.992-4.426,17.992-4.426",
    transform: "translate(272.568 117.143)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275797",
    "data-name": "Path 275797",
    d: "M69.39,30.018c-.5,4.738,4.036,8.353,6.983,11.469a.393.393,0,0,1-.1.638c-2.537,3.239-5.173,8.551-3.9,12.705a.1.1,0,0,1-.183.074c-1.973-4.268.188-9.7,3.195-13.071-3.071-3.145-7.458-6.973-6.039-11.82,0-.03.049-.025.045,0",
    transform: "translate(272.521 118.337)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275798",
    "data-name": "Path 275798",
    d: "M91.5,36.789,69.561,63.96S98.705,79.623,106.3,78.2s16.988-8.022,35.88-29.668c14.96-17.151,3.121-17.3-6.2-12.616C128.354,39.737,109,48.466,107.464,47.783S91.5,36.789,91.5,36.789",
    transform: "translate(274.457 131.348)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275799",
    "data-name": "Path 275799",
    d: "M69.562,63.964s26.365,14.169,35.465,14.327a6.693,6.693,0,0,0,1.266-.089c7.587-1.434,16.993-8.027,35.89-29.678,6.612-7.586,7.987-11.845,6.662-13.833-1.691-2.493-7.666-1.395-12.873,1.222C128.36,39.736,109,48.47,107.46,47.783S91.51,36.789,91.51,36.789Z",
    transform: "translate(274.461 131.348)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275800",
    "data-name": "Path 275800",
    d: "M90.682,35.314c-2.972,4.209-6.147,8.284-9.392,12.28-1.6,1.963-3.19,3.932-4.857,5.831-1.736,1.983-3.59,3.862-5.312,5.851-.079.089-.223-.02-.148-.114,1.652-2.033,3.16-4.194,4.768-6.266,1.548-2,3.155-3.947,4.748-5.915,3.244-4.006,6.508-8.007,9.891-11.9a.191.191,0,0,1,.3.232",
    transform: "translate(279.948 138.139)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275801",
    "data-name": "Path 275801",
    d: "M83.428,86.192l-.707,14.683s17.354,1.9,60.272,1.9c0,0-9.05-45.811-23.576-62.863-7.265-8.531-16.2-8.264-22.1-2.725-1.494,1.4-15.331,24.594-17.473,33.18-1.869,7.572,3.581,15.821,3.581,15.821",
    transform: "translate(313.502 131.138)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275802",
    "data-name": "Path 275802",
    d: "M91.232,35.012c-2.844,10.94-8.843,21.988-8.4,33.373.519,3.863,2.374,7.493,4.219,10.831q-.453,7.76-1.2,15.509-.03-7.782.232-15.554c-1.592-1.8-3.813-7.122-4.342-10.618-.475-11.785,5.771-22.651,9.486-33.541",
    transform: "translate(322.434 138.14)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275803",
    "data-name": "Path 275803",
    d: "M81.966,38.623a.961.961,0,0,0,.757,1.078.877.877,0,0,0,.964-.826.953.953,0,0,0-.757-1.073.873.873,0,0,0-.964.821",
    transform: "translate(323.376 149.113)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275804",
    "data-name": "Path 275804",
    d: "M81.276,40.8a.961.961,0,0,0,.757,1.078A.877.877,0,0,0,83,41.055a.953.953,0,0,0-.757-1.073.876.876,0,0,0-.964.821",
    transform: "translate(320.654 157.715)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275805",
    "data-name": "Path 275805",
    d: "M81.276,42.993a.961.961,0,0,0,.757,1.078A.877.877,0,0,0,83,43.246a.953.953,0,0,0-.757-1.073.873.873,0,0,0-.964.821",
    transform: "translate(320.654 166.355)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275806",
    "data-name": "Path 275806",
    d: "M81.966,44.775a.961.961,0,0,0,.757,1.078.877.877,0,0,0,.964-.826.953.953,0,0,0-.757-1.073.873.873,0,0,0-.964.821",
    transform: "translate(323.376 173.386)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275807",
    "data-name": "Path 275807",
    d: "M81.82,46.761a.961.961,0,0,0,.757,1.078.877.877,0,0,0,.964-.826.953.953,0,0,0-.757-1.073.873.873,0,0,0-.964.821",
    transform: "translate(322.8 181.222)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275808",
    "data-name": "Path 275808",
    d: "M88.77,36.868c-1.464,2.458-2.824,4.975-4.149,7.507.322-1.2.712-2.374,1.118-3.541.035-.094-.119-.153-.158-.064a16.579,16.579,0,0,0-1.4,4.456c-.425.821-.865,1.637-1.286,2.468-.826,1.652-1.667,3.294-2.334,5.02a17.465,17.465,0,0,0-1.108,5.41c-.01.1.158.119.168.02a19.289,19.289,0,0,1,1.731-5.391c.747-1.706,1.588-3.378,2.4-5.054,1.741-3.576,3.467-7.156,5.109-10.781a.051.051,0,0,0-.089-.049",
    transform: "translate(313.462 145.359)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275809",
    "data-name": "Path 275809",
    d: "M120,39.863C129.4,56.139,146,89.6,140.437,98.854,134.923,108.033,103.613,114.1,92.915,116c-3.521.623-16.241-24.481-12.74-26.024,5.94-2.626,34.159-7.75,35.059-9.664.569-1.2-4.965-23.125-5.618-36.023-.851-16.76,7.468-9.481,10.386-4.426",
    transform: "translate(313.956 133.6)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275810",
    "data-name": "Path 275810",
    d: "M118.618,45s-11.1,1.543-18.308,2.9C96.284,48.647,89.5,50.556,86.8,52.46c-4.041,2.854-19.124,17.354-15.687,21.088C74.227,76.926,85.6,62.821,85.6,62.821s-12.735,13.219-8.239,16.6S92.59,65.15,92.59,65.15s-12.784,13.877-7.6,16.627c3.917,2.082,14.54-13.353,14.54-13.353s-10.9,12-6.963,14.312c4.352,2.557,15.049-11.078,15.049-11.078,11,4.194,17.957,1.691,22.69-.678C131.457,70.407,118.618,45,118.618,45",
    transform: "translate(278.599 177.536)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275811",
    "data-name": "Path 275811",
    d: "M84.7,47.63c-1.553,1.5-3.135,3.007-4.55,4.634s-2.769,3.314-4.026,5.069a36.667,36.667,0,0,0-4.233,7.3c2.339-4.446,7.31-10.361,8.724-11.993s2.74-3.328,4.149-4.96c.035-.04-.03-.084-.064-.049",
    transform: "translate(283.618 187.876)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275812",
    "data-name": "Path 275812",
    d: "M84.228,48.638c-1.9,2-3.858,3.912-5.673,6s-3.328,4.2-4.985,6.39c-.129.168,0,.183.138.02,1.746-2.127,3.516-3.956,5.282-6.058s3.452-4.278,5.287-6.311c.03-.03-.02-.069-.049-.04",
    transform: "translate(290.071 191.862)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275813",
    "data-name": "Path 275813",
    d: "M83.266,49.325A61.469,61.469,0,0,0,75.3,59.161c-.119.173.054.168.183,0,2.591-3.318,4.594-5.945,7.888-9.733.049-.054-.04-.163-.1-.1",
    transform: "translate(296.939 194.544)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275814",
    "data-name": "Path 275814",
    d: "M80.115,89.1,102.667,117s32.631-7.478,37.275-18.61-11.093-42.418-19.792-55.37-14.209-12.636-13.195,2.211c.91,13.3,5.836,34.668,5.321,35.4S80.115,89.1,80.115,89.1",
    transform: "translate(316.098 132.893)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275815",
    "data-name": "Path 275815",
    d: "M82.1,44.836c3.511,3.769,6.855,7.71,10.1,11.706,1.6,1.958,3.195,3.927,4.713,5.945,1.583,2.1,3.046,4.3,4.639,6.395.074.094-.064.213-.139.119-1.652-2.033-3.462-3.947-5.158-5.945-1.642-1.924-3.225-3.9-4.822-5.856-3.259-4-6.508-8.012-9.624-12.117a.189.189,0,0,1,.287-.247",
    transform: "translate(322.629 176.643)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275816",
    "data-name": "Path 275816",
    d: "M80.173,68.967c2.517-.2,32.448-7.878,32.482-7.888.059-.035-1.454-9.505-1.771-11.3q-.957-5.49-2.146-10.94c-.01-.079-.158-.074-.148.01.173,2.211.42,4.426.712,6.622-.331-.954-.692-1.914-1.108-2.839-.035-.079-.163-.025-.138.054.495,1.864,1.063,3.719,1.632,5.559.079.49.124.974.2,1.464q.452,2.752.974,5.495c.178.9.866,4.387,1.029,5.321-3.976.781-29.451,7.359-31.76,8.249-.084.035-.054.2.04.188",
    transform: "translate(315.976 153.037)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275817",
    "data-name": "Path 275817",
    d: "M93.475,46.813a9.085,9.085,0,0,1-1.563,2.4c-.089.079.025.1.134.025a4.483,4.483,0,0,0,1.474-2.359c.01-.059-.015-.119-.044-.064",
    transform: "translate(362.52 184.617)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275818",
    "data-name": "Path 275818",
    d: "M98,48.872c-.178,1.133-4.946,8.773-10.059,8.922-1.667.045-2.32-9.031-2.32-9.031l-.2-.663-2.814-9.228L93.1,30.959l1.523-1.053s.6,2.572,1.32,5.786q.052.223.1.46c.044.178.089.351.124.519.114.48.228.969.331,1.459.079.371.158.737.228,1.128s.153.776.232,1.172A61.881,61.881,0,0,1,98,48.872",
    transform: "translate(325.95 117.994)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275819",
    "data-name": "Path 275819",
    d: "M95.945,35.7A19.36,19.36,0,0,1,85.426,48.106l-2.814-9.228L93.1,30.964l1.523-1.058s.6,2.577,1.32,5.791",
    transform: "translate(325.95 117.994)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275820",
    "data-name": "Path 275820",
    d: "M80.1,43.81c-2.112,16.8,7.71,19.96,11.335,20.41,3.289.41,14.535,1.39,18.373-15.1S106.5,26.337,99.028,25,82.209,27.01,80.1,43.81",
    transform: "translate(314.865 97.601)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275821",
    "data-name": "Path 275821",
    d: "M81.078,29.057c.4,0,.772-.064,1.172-.1a1.945,1.945,0,0,0,1.177-.331.611.611,0,0,0,.084-.737,1.51,1.51,0,0,0-1.429-.529,2.232,2.232,0,0,0-1.469.608.648.648,0,0,0,.465,1.088",
    transform: "translate(317.337 107.928)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275822",
    "data-name": "Path 275822",
    d: "M84.613,29.605a10.931,10.931,0,0,1-1.113-.381,1.912,1.912,0,0,1-1.063-.608.607.607,0,0,1,.094-.732,1.494,1.494,0,0,1,1.513-.168,2.208,2.208,0,0,1,1.281.945.648.648,0,0,1-.712.945",
    transform: "translate(324.929 108.863)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275823",
    "data-name": "Path 275823",
    d: "M82.385,28.812c.015-.045.084.069.074.114-.208,1.142-.247,2.483.737,3.017.03.02.015.074-.02.064-1.241-.366-1.167-2.146-.791-3.195",
    transform: "translate(324.1 113.638)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275824",
    "data-name": "Path 275824",
    d: "M83.526,28.594c1.864.129,1.469,3.853-.262,3.734-1.7-.119-1.3-3.843.262-3.734",
    transform: "translate(324.161 112.807)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275825",
    "data-name": "Path 275825",
    d: "M82.769,28.67c.3.247.584.653.969.732.45.094.831-.257,1.167-.6.04-.035.064,0,.059.049-.064.717-.415,1.419-1.192,1.444-.707.02-1.142-.663-1.241-1.4-.02-.138.114-.321.237-.223",
    transform: "translate(325.625 113.008)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275826",
    "data-name": "Path 275826",
    d: "M82.156,28.616c0-.045-.094.045-.1.094-.079,1.157-.361,2.468-1.444,2.75-.035.01-.035.064,0,.064,1.291-.054,1.652-1.8,1.538-2.908",
    transform: "translate(317.964 112.855)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275827",
    "data-name": "Path 275827",
    d: "M82.072,28.358c-1.845-.326-2.359,3.383-.653,3.684,1.682.3,2.2-3.412.653-3.684",
    transform: "translate(317.138 111.807)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275828",
    "data-name": "Path 275828",
    d: "M82.132,28.743c-.321.158-.658.475-1.014.445-.411-.03-.653-.47-.861-.89-.02-.045-.054-.02-.059.03-.119.707.01,1.479.673,1.711.6.208,1.147-.336,1.414-1.019.049-.129-.025-.341-.153-.277",
    transform: "translate(316.272 111.556)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275829",
    "data-name": "Path 275829",
    d: "M83.808,30.678c-.292.252-.593.608-1.014.618a3.013,3.013,0,0,1-1.227-.366c-.04-.015-.079.02-.054.054a1.558,1.558,0,0,0,1.429.722,1.243,1.243,0,0,0,.974-.969c.02-.064-.064-.094-.109-.059",
    transform: "translate(321.584 120.981)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275830",
    "data-name": "Path 275830",
    d: "M82.668,38.616s-.44,1.691-.539,2.5c-.01.079.183.138.455.183l.035,0a3.874,3.874,0,0,0,3.917-.994c.064-.069-.03-.168-.109-.124a5.859,5.859,0,0,1-3.64.589c-.03-.232.851-2.873.727-2.9a7.285,7.285,0,0,0-1.894.2c.821-3.551,2.2-6.939,2.962-10.49a.11.11,0,0,0-.2-.079A58.881,58.881,0,0,0,80.7,38.67c-.119.455,1.622.045,1.963-.054",
    transform: "translate(318.402 108.31)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275831",
    "data-name": "Path 275831",
    d: "M81.122,30.872a4.637,4.637,0,0,0,1.6,1.691,2.079,2.079,0,0,0,1.231.267c.93-.094,1.083-.915,1.029-1.647a4.9,4.9,0,0,0-.237-1.137,5.97,5.97,0,0,1-3.62.826",
    transform: "translate(320.072 118.546)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275832",
    "data-name": "Path 275832",
    d: "M81.446,31.655a2.056,2.056,0,0,0,1.222.267c.935-.094,1.083-.915,1.029-1.642a2.126,2.126,0,0,0-2.25,1.375",
    transform: "translate(321.35 119.454)",
    fill: "#ffe7cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275833",
    "data-name": "Path 275833",
    d: "M108.255,49.461c-3.155.475-4.134-6.756-4.134-6.756S90.589,40.727,89.194,29.778A18.586,18.586,0,0,1,80.06,40.158s.193-12.047,9.678-14.6c0,0,11.741-4.58,18.61,4.664s2.023,18.927-.094,19.243",
    transform: "translate(315.881 96.347)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275834",
    "data-name": "Path 275834",
    d: "M81.923,25.34a11.918,11.918,0,0,0,.717,5,12.43,12.43,0,0,0,2.646,4.377,11.286,11.286,0,0,0,.93.89l.48.43c.168.129.346.252.519.371.356.242.7.495,1.068.722.376.2.757.391,1.138.579.193.094.381.2.574.282l.6.213,1.2.43c.821.208,1.647.371,2.468.524-.781-.321-1.578-.554-2.344-.875l-1.128-.519-.564-.257c-.178-.1-.351-.213-.529-.317-.351-.213-.7-.425-1.058-.628-.336-.227-.653-.49-.984-.727l-.49-.366-.445-.42a10.1,10.1,0,0,1-.87-.851,14.227,14.227,0,0,1-2.661-4.07,16.163,16.163,0,0,1-1.261-4.782",
    transform: "translate(323.088 99.978)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275835",
    "data-name": "Path 275835",
    d: "M86.185,32.72s3.9-5.138,6.241-3.729-.727,8.956-3.581,9.9A2.861,2.861,0,0,1,85.072,37.2Z",
    transform: "translate(335.656 113.419)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275836",
    "data-name": "Path 275836",
    d: "M90.261,29.229a.038.038,0,0,1,.01.074c-2,.727-3.111,2.512-3.912,4.382a1.584,1.584,0,0,1,2.384-.341c.049.04,0,.119-.059.1a1.764,1.764,0,0,0-1.958.539,8.453,8.453,0,0,0-.989,1.533c-.1.173-.415.064-.341-.134l.02-.049c.045-2.512,2.136-5.959,4.847-6.108",
    transform: "translate(336.887 115.323)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275837",
    "data-name": "Path 275837",
    d: "M85.311,34.452l2.522,7.774L97.888,33.29l2.453,3.254S90.113,51.129,90.1,50.436L87.428,43.7l-4.812,4.233,1.142-11.365Z",
    transform: "translate(325.966 131.346)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275838",
    "data-name": "Path 275838",
    d: "M83.1,39.709c.252-1.869.45-3.759.791-5.618.01-.064.114-.089.129-.01.252,1.84-.747,8.986-.856,10.712l.02-.02c.2-.183,4.446-3.709,4.481-3.645.6,1.078,2.572,5.984,2.7,6.429,1.622-2.319,8.442-11.424,10.316-13.59a.066.066,0,0,1,.109.074C99.326,36.5,90.5,48.532,90.385,48.487A73.194,73.194,0,0,1,87.6,41.371c-.732.781-5.044,4.792-5.04,4.515a58.7,58.7,0,0,1,.544-6.177",
    transform: "translate(325.729 133.922)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275839",
    "data-name": "Path 275839",
    d: "M9.469,89.194A83.981,83.981,0,0,1,11.412,75.51c.964-4.05,2.334-8.195,4.891-11.543a14.656,14.656,0,0,1,9.584-5.974c3.754-.455,7.28,1.217,10.084,3.581,3.482,2.928,6.142,6.81,8.645,10.569a130.215,130.215,0,0,1,7.468,13.066c.074.148-.153.272-.228.124A82.1,82.1,0,0,0,45.181,74.4a68.955,68.955,0,0,0-7.69-9.308c-2.577-2.512-5.851-4.866-9.584-4.985a11.768,11.768,0,0,0-9.377,4.832c-2.5,3.2-3.773,7.2-4.723,11.093a82.608,82.608,0,0,0-1.929,13.027c-.732,9.016-.93,18.086-1.133,27.121q-.178,7.678-.232,15.351-.037,3.887-.064,7.779a47.405,47.405,0,0,1-.3,7.5c-.084.5-.905.455-.989-.025a44.271,44.271,0,0,1-.346-7.107q-.052-3.687-.089-7.369c-.04-4.777-.064-9.555-.049-14.332.025-9.585.143-19.213.8-28.778",
    transform: "translate(34.201 228.516)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275840",
    "data-name": "Path 275840",
    d: "M12.973,85.076c.475-2.552,1.335-5.875,2.789-7.849,2.611-3.546,5.43-2,2.824,1.924a23.515,23.515,0,0,0-3.665,9.693s4.387,6.266,9.683,9.352c-.227-2.409-.91-6.118-.44-9.693,1.019-7.74,5.7-7.3,4.545-1.157a53.289,53.289,0,0,0-1.058,12.443,26.242,26.242,0,0,0,5.658,2.77c-.307-.9-.628-1.973-.984-3.279-1.879-6.944,2.75-9.11,2.9-5.2a54.717,54.717,0,0,0,1.8,9.847c2.537.856,4.644,1.434,5.93,1.889a21.685,21.685,0,0,1,8.684,5.93,27.328,27.328,0,0,0,5.915-7.651c-1.617-1.395-4.174-3.462-7.725-5.969-6.657-4.7-4.342-10.628.94-6.944,3.808,2.666,6.761,7.6,8.1,10.129a41.1,41.1,0,0,0,3.022-13.857C56.657,82.543,43.73,75.7,47.627,75.7c3.506,0,11.35,5.143,14.228,7.127a35.926,35.926,0,0,0-.44-4.026c-4.926-3.229-20.92-8.249-18.373-9.693C45.841,67.529,57,72.7,60.376,74.329a20.164,20.164,0,0,0-2.957-6.123C50.619,59.1,38.354,55.961,33,57.7c-3.788,1.231-2.68,10.836-3.5,10.509-15.213-6.123-22.131-1.8-16.533,16.869m37.29-1.053c1.078-1.306,6.073,2.532,4.629,4.629s-6.024-2.957-4.629-4.629M24.175,75.827c1.316.836-.628,5.687-2.651,4.219-1.726-1.251,1.33-5.064,2.651-4.219",
    transform: "translate(43.579 225.84)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87492",
    "data-name": "Group 87492",
    transform: "translate(54.623 283.079)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87491",
    "data-name": "Group 87491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87490",
    "data-name": "Group 87490",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275841",
    "data-name": "Path 275841",
    d: "M12.973,85.076c.475-2.552,1.335-5.875,2.789-7.849,2.611-3.546,5.43-2,2.824,1.924a23.515,23.515,0,0,0-3.665,9.693s4.387,6.266,9.683,9.352c-.227-2.409-.91-6.118-.44-9.693,1.019-7.74,5.7-7.3,4.545-1.157a53.289,53.289,0,0,0-1.058,12.443,26.242,26.242,0,0,0,5.658,2.77c-.307-.9-.628-1.973-.984-3.279-1.879-6.944,2.75-9.11,2.9-5.2a54.717,54.717,0,0,0,1.8,9.847c2.537.856,4.644,1.434,5.93,1.889a21.685,21.685,0,0,1,8.684,5.93,27.328,27.328,0,0,0,5.915-7.651c-1.617-1.395-4.174-3.462-7.725-5.969-6.657-4.7-4.342-10.628.94-6.944,3.808,2.666,6.761,7.6,8.1,10.129a41.1,41.1,0,0,0,3.022-13.857C56.657,82.543,43.73,75.7,47.627,75.7c3.506,0,11.35,5.143,14.228,7.127a35.926,35.926,0,0,0-.44-4.026c-4.926-3.229-20.92-8.249-18.373-9.693C45.841,67.529,57,72.7,60.376,74.329a20.164,20.164,0,0,0-2.957-6.123C50.619,59.1,38.354,55.961,33,57.7c-3.788,1.231-2.68,10.836-3.5,10.509-15.213-6.123-22.131-1.8-16.533,16.869m37.29-1.053c1.078-1.306,6.073,2.532,4.629,4.629s-6.024-2.957-4.629-4.629M24.175,75.827c1.316.836-.628,5.687-2.651,4.219-1.726-1.251,1.33-5.064,2.651-4.219",
    transform: "translate(-11.044 -57.239)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275842",
    "data-name": "Path 275842",
    d: "M17.1,68.2c.687-1.355,1.4-2.705,2.186-4.011A23.492,23.492,0,0,1,21.8,60.54c-.218-.267-.425-.539-.648-.8-.089-.109.064-.257.158-.153.257.292.5.589.747.885a.232.232,0,0,1,.1.124c.94,1.128,1.825,2.29,2.671,3.472a40.648,40.648,0,0,1,4.421,1.281c1.489.5,2.967,1.019,4.416,1.627.153.064.079.317-.069.247-1.439-.633-2.9-1.251-4.387-1.751-1.409-.48-2.839-.846-4.268-1.246.465.653.92,1.316,1.355,1.988A51.982,51.982,0,0,1,34.11,69.4c2.641,1.256,5.183,2.71,7.71,4.174a.128.128,0,0,1-.134.218,85.838,85.838,0,0,0-7.671-3.966c-2.448-1.147-4.98-2.087-7.448-3.18,6.212,9.7,9.941,20.885,14.926,31.241.069.148-.168.277-.232.124-1.518-3.63-3.269-7.171-4.926-10.747-1.489-3.2-2.938-6.429-4.426-9.639-.435-.94-.885-1.874-1.34-2.809.272,5.178.163,10.445,1.009,15.564a.128.128,0,1,1-.252.03c-.361-5.534-1.335-10.984-1.3-16.548,0-.03.025-.045.03-.069-1.053-2.117-2.176-4.2-3.388-6.236-2.057,4.847-4.224,9.767-5.183,14.97-.03.158-.292.089-.247-.074,1.4-5.218,2.7-10.44,5.208-15.262a58.919,58.919,0,0,0-4.372-6.306c-.692,1.291-1.578,2.507-2.364,3.739-.767,1.2-1.518,2.408-2.225,3.65a53.216,53.216,0,0,0-3.887,8.21c-.054.158-.312.079-.247-.074,1.187-2.755,2.389-5.529,3.744-8.21",
    transform: "translate(52.645 234.955)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275843",
    "data-name": "Path 275843",
    d: "M4.23,71.048c3.986-4,8.62-9.248,14.782-9.233,5.945.01,10.321,4.8,12.834,9.733,2.631,5.168,3.576,11.019,4.317,16.706a202.359,202.359,0,0,1,1.578,20.539c.109,3.813.094,7.626,0,11.439a75.763,75.763,0,0,1-.875,11.548c-.109.613-1.1.638-1.137-.025-.178-3.215-.049-6.439-.03-9.654q.022-4.74-.148-9.491c-.237-6.4-.7-12.784-1.454-19.144-.653-5.554-1.177-11.266-2.839-16.632-1.5-4.837-4.308-10.371-9.214-12.5-6.7-2.9-13.234,2.4-17.616,6.874-.114.119-.317-.044-.2-.163",
    transform: "translate(16.547 243.893)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275844",
    "data-name": "Path 275844",
    d: "M.121,87.341v.01c.03.816.079,1.627.134,2.413a14.412,14.412,0,0,1,6.533-2.705c5.658-.6,5.3,3.7,1.518,3.882A21.555,21.555,0,0,0,.541,92.494c.925,7.473,2.977,13.477,3.289,13.561a110.107,110.107,0,0,0,14.945-1.889c-1.4-3-4.609-6.983-2.977-7.3,1.672-.331,3.422,3.224,4.322,7.033A71.589,71.589,0,0,0,31,100.9c-2.488-2.151-6.335-4.832-4.866-5.974s4.525,2.631,6.355,5.376a22.06,22.06,0,0,0,4.7-2.621c-3.353-4.926-11.528-5.93-10.46-9.491,1.088-3.63,8.714,1.38,12.146,7.972,4.031-4.179,5.213-10.1,4.787-15.153-3.511-.41-10.267.331-9.777-2.191.46-2.4,5.371-2.043,9.367-.569A14,14,0,0,0,40.9,72.687c-3.7-4.753-14.995,1.291-14.995,1.291s1.207-11.35-3.1-13.313c-2.483-1.128-6.864-1.118-11.261,1.469,2.468.2,5.445.984,6.642,2.7,1.533,2.181-.885,3.368-2.418,2.364-1.083-.717-3.106-2.962-6.751-3.259a22.464,22.464,0,0,0-4.075,4.515,22.233,22.233,0,0,0-1.192,1.879,15.485,15.485,0,0,1,13.219.237c4.9,2.433,2.166,7.517-2.047,5.539-4.169-1.949-8.229-3.917-12.7-2.8A31.7,31.7,0,0,0,.081,85.966a22.183,22.183,0,0,1,7.255-3.482c4.866-1.276,6.34,1.632.989,2.176a21.45,21.45,0,0,0-8.2,2.68m5.925-7.814c-.336-1.578,3.116-2.033,3.689-.752.48,1.093-3.363,2.329-3.689.752m29.54,8.734c.321-.861,2.631.119,2.423,1.192-.287,1.434-2.74-.331-2.423-1.192m-16.31,5.534c1.681-.673,4.313,3.511,2.478,4.471s-3.853-3.917-2.478-4.471",
    transform: "translate(0.314 236.532)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87495",
    "data-name": "Group 87495",
    transform: "translate(0.396 296.482)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87494",
    "data-name": "Group 87494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87493",
    "data-name": "Group 87493",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275845",
    "data-name": "Path 275845",
    d: "M.121,87.341v.01c.03.816.079,1.627.134,2.413a14.412,14.412,0,0,1,6.533-2.705c5.658-.6,5.3,3.7,1.518,3.882A21.555,21.555,0,0,0,.541,92.494c.925,7.473,2.977,13.477,3.289,13.561a110.107,110.107,0,0,0,14.945-1.889c-1.4-3-4.609-6.983-2.977-7.3,1.672-.331,3.422,3.224,4.322,7.033A71.589,71.589,0,0,0,31,100.9c-2.488-2.151-6.335-4.832-4.866-5.974s4.525,2.631,6.355,5.376a22.06,22.06,0,0,0,4.7-2.621c-3.353-4.926-11.528-5.93-10.46-9.491,1.088-3.63,8.714,1.38,12.146,7.972,4.031-4.179,5.213-10.1,4.787-15.153-3.511-.41-10.267.331-9.777-2.191.46-2.4,5.371-2.043,9.367-.569A14,14,0,0,0,40.9,72.687c-3.7-4.753-14.995,1.291-14.995,1.291s1.207-11.35-3.1-13.313c-2.483-1.128-6.864-1.118-11.261,1.469,2.468.2,5.445.984,6.642,2.7,1.533,2.181-.885,3.368-2.418,2.364-1.083-.717-3.106-2.962-6.751-3.259a22.464,22.464,0,0,0-4.075,4.515,22.233,22.233,0,0,0-1.192,1.879,15.485,15.485,0,0,1,13.219.237c4.9,2.433,2.166,7.517-2.047,5.539-4.169-1.949-8.229-3.917-12.7-2.8A31.7,31.7,0,0,0,.081,85.966a22.183,22.183,0,0,1,7.255-3.482c4.866-1.276,6.34,1.632.989,2.176a21.45,21.45,0,0,0-8.2,2.68m5.925-7.814c-.336-1.578,3.116-2.033,3.689-.752.48,1.093-3.363,2.329-3.689.752m29.54,8.734c.321-.861,2.631.119,2.423,1.192-.287,1.434-2.74-.331-2.423-1.192m-16.31,5.534c1.681-.673,4.313,3.511,2.478,4.471s-3.853-3.917-2.478-4.471",
    transform: "translate(-0.081 -59.95)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275846",
    "data-name": "Path 275846",
    d: "M.984,93.678c2.537-4.243,5.044-8.506,7.71-12.671Q10.556,78.1,12.582,75.3c-.2-.04-.406-.1-.6-.143q-.5-.1-1.009-.193c-.781-.134-1.568-.247-2.354-.326-.737-.074-1.484-.119-2.226-.124a10.969,10.969,0,0,0-2.384.124c-.094.02-.109-.129-.02-.129.8.035,1.607-.069,2.4-.079.772-.015,1.543,0,2.315.054.722.04,1.439.114,2.156.223.4.059.791.129,1.182.208a7.1,7.1,0,0,1,.717.148q2.055-2.834,4.273-5.554A50.8,50.8,0,0,0,3.141,65.078c-.084-.015-.054-.138.03-.129a47.105,47.105,0,0,1,14.09,4.278c.811-1,1.627-1.988,2.448-2.977.915-1.1,1.9-2.181,2.73-3.353a.065.065,0,1,1,.1.079,46.939,46.939,0,0,0-3.22,3.942h.02a48.987,48.987,0,0,1,5.163,4.149q2.537,2.24,4.936,4.634c.059.054-.03.148-.089.089-1.583-1.568-3.22-3.071-4.936-4.5S20.9,68.56,19.174,67.15l-.015-.025c-.391.519-.786,1.043-1.182,1.553-.2.262-.4.519-.593.781l-.045.054q-.987,1.291-1.968,2.587a20.7,20.7,0,0,1,1.958,3.536c.569,1.2,1.063,2.433,1.518,3.68a53.779,53.779,0,0,1,2.117,7.948c.015.079-.109.119-.124.035a46.49,46.49,0,0,0-2.31-7.789c-.495-1.3-1.053-2.562-1.632-3.823-.529-1.147-1.167-2.25-1.662-3.412q-.853,1.135-1.691,2.28c-.158.223-.317.45-.475.677.025.049.01.114-.054.114h-.03c-1.741,2.433-3.4,4.926-5.015,7.443a2.36,2.36,0,0,1,.223.554c.1.307.2.613.292.925a19.021,19.021,0,0,1,.44,1.889c.109.6.193,1.2.252,1.805a17.58,17.58,0,0,0,.153,2.052c.025.1-.143.109-.124,0A6.608,6.608,0,0,0,9.065,88.1c-.089-.653-.213-1.306-.361-1.949-.138-.584-.3-1.162-.47-1.736-.084-.287-.178-.574-.277-.856-.054-.153-.124-.312-.178-.47-.752,1.182-1.5,2.374-2.24,3.571q-2.188,3.553-4.362,7.122c-.074.124-.267.02-.193-.1",
    transform: "translate(3.818 248.048)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275847",
    "data-name": "Path 275847",
    d: "M8.883,108.7c.064-2.4.445-4.827.707-7.216s.529-4.8.786-7.206c.495-4.629.772-9.362,1.86-13.9a20.228,20.228,0,0,1,5.658-10.4,9.229,9.229,0,0,1,5.544-2.646,9.557,9.557,0,0,1,5.89,1.815,20.532,20.532,0,0,1,4.951,5.217,50.711,50.711,0,0,1,3.862,6.271c.045.084-.084.134-.129.059a32.131,32.131,0,0,0-8.358-9.362,9.844,9.844,0,0,0-5.267-2.2,7.135,7.135,0,0,0-5.1,2.038c-2.8,2.433-4.426,6.019-5.4,9.54A97.745,97.745,0,0,0,11.8,93.557c-.341,2.542-.663,5.089-1,7.631s-.544,5.129-1.083,7.621a.422.422,0,0,1-.836-.114",
    transform: "translate(35.048 265.607)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275848",
    "data-name": "Path 275848",
    d: "M13.72,90.953a13.324,13.324,0,0,0,2.616,2.671c-.4-2.344-.875-6.513.312-8.734,1.835-3.447,4.016-1.726,2.918,1.271a24.409,24.409,0,0,0-1.771,8.5,36.878,36.878,0,0,0,7.987,3.764,13.368,13.368,0,0,1-.262-4.11c.366-3.684,3.185-3.615,2.453.218a23.37,23.37,0,0,0-.386,4.5,83.149,83.149,0,0,0,12.448,2.809,36.332,36.332,0,0,0,5.148-9.169c-3-.752-9.07-.925-8.942-3.066.173-2.883,6.053-.663,9.5,1.429a23.022,23.022,0,0,0,1.039-7.76,38.456,38.456,0,0,0-8.269-1.37c-6.177-.534-5.87-4.036-1.4-3.956,3.3.059,7.478,2.082,9.461,3.135-1.291-8.4-7.7-13.783-12.834-13.991-8.64-.346-5.529,10.4-5.529,10.4s-5.851-4.12-11.375-4.011S7.815,82.738,13.72,90.953M36.786,75.419c-.188-1.212,3.665-1.5,3.867.049.228,1.741-3.67,1.177-3.867-.049m6.2,12.606c-.079-.791,1.588-.93,1.963.069.252.648-1.894.712-1.963-.069m-20.737.737c1.3.183,2.043,4.837-.2,4.748-1.711-.074-.905-4.906.2-4.748",
    transform: "translate(42.036 264.675)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87498",
    "data-name": "Group 87498",
    transform: "translate(52.692 331.759)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87497",
    "data-name": "Group 87497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87496",
    "data-name": "Group 87496",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275849",
    "data-name": "Path 275849",
    d: "M13.72,90.953a13.324,13.324,0,0,0,2.616,2.671c-.4-2.344-.875-6.513.312-8.734,1.835-3.447,4.016-1.726,2.918,1.271a24.409,24.409,0,0,0-1.771,8.5,36.878,36.878,0,0,0,7.987,3.764,13.368,13.368,0,0,1-.262-4.11c.366-3.684,3.185-3.615,2.453.218a23.37,23.37,0,0,0-.386,4.5,83.149,83.149,0,0,0,12.448,2.809,36.332,36.332,0,0,0,5.148-9.169c-3-.752-9.07-.925-8.942-3.066.173-2.883,6.053-.663,9.5,1.429a23.022,23.022,0,0,0,1.039-7.76,38.456,38.456,0,0,0-8.269-1.37c-6.177-.534-5.87-4.036-1.4-3.956,3.3.059,7.478,2.082,9.461,3.135-1.291-8.4-7.7-13.783-12.834-13.991-8.64-.346-5.529,10.4-5.529,10.4s-5.851-4.12-11.375-4.011S7.815,82.738,13.72,90.953M36.786,75.419c-.188-1.212,3.665-1.5,3.867.049.228,1.741-3.67,1.177-3.867-.049m6.2,12.606c-.079-.791,1.588-.93,1.963.069.252.648-1.894.712-1.963-.069m-20.737.737c1.3.183,2.043,4.837-.2,4.748-1.711-.074-.905-4.906.2-4.748",
    transform: "translate(-10.656 -67.084)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275850",
    "data-name": "Path 275850",
    d: "M13.37,73.916c.213-.579.406-1.167.589-1.761-.168.6-.317,1.2-.43,1.805a.083.083,0,1,1-.158-.044",
    transform: "translate(52.723 284.69)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275851",
    "data-name": "Path 275851",
    d: "M15.076,77.806c.406-1.192.861-2.374,1.32-3.541.252-.628.5-1.246.781-1.865a7.6,7.6,0,0,1,.767-1.558,12.183,12.183,0,0,1-.7-1.508.046.046,0,0,1,.079-.045A18.219,18.219,0,0,1,19.007,71.9c.242.406.47.821.707,1.231a12.966,12.966,0,0,1,1.449.223c.519.1,1.034.2,1.548.317s1.029.237,1.543.361,1.014.287,1.528.366c.119.02.069.208-.045.163a9.538,9.538,0,0,0-1.612-.42c-.5-.109-.994-.2-1.5-.267s-1-.134-1.508-.183c-.376-.04-.762-.059-1.142-.094.208.361.42.717.623,1.083l.089.178A4.815,4.815,0,0,1,21.93,75c.445.079.89.168,1.335.262.9.2,1.8.415,2.685.663,1.869.519,3.714,1.118,5.559,1.721.1.035.04.188-.064.153a54.59,54.59,0,0,0-5.584-1.548c-.885-.2-1.766-.4-2.651-.589-.445-.089-.89-.188-1.335-.282a9.08,9.08,0,0,1-1.029-.228c.95,1.756,1.845,3.541,2.666,5.361,1.79,3.961,3.3,8.046,4.837,12.112.04.1-.119.168-.153.064a111.063,111.063,0,0,0-5.148-11.84c-.341-.7-.7-1.4-1.048-2.1-.03.143-.064.282-.089.43-.089.48-.173.959-.257,1.439-.158.964-.326,1.929-.47,2.893a34.165,34.165,0,0,0-.7,6c0,.124-.183.119-.163,0,.153-.959.153-1.958.213-2.923.064-1.014.138-2.023.257-3.027.114-.969.237-1.944.4-2.9.079-.485.163-.964.252-1.444a2.831,2.831,0,0,1,.272-1.044c-.5-1.019-1-2.033-1.518-3.046q-.72-1.424-1.459-2.839c-.208-.4-.435-.8-.658-1.207a11.1,11.1,0,0,1-.574,1.454c-.218.544-.44,1.088-.668,1.637-.495,1.2-.954,2.418-1.414,3.64-.653,1.726-1.375,3.5-1.914,5.292.529-1.761.974-3.561,1.568-5.3",
    transform: "translate(53.297 273.321)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275852",
    "data-name": "Path 275852",
    d: "M13.483,72.487c.04-.139.084-.277.124-.415-.04.139-.079.277-.124.415",
    transform: "translate(53.198 284.362)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275853",
    "data-name": "Path 275853",
    d: "M5.963,74.739,6.572,87.6l1.563,33.135H42.323L43.886,87.6l.608-12.858Z",
    transform: "translate(23.528 294.886)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275854",
    "data-name": "Path 275854",
    d: "M5.963,74.739,6.572,87.6H43.886l.608-12.858Z",
    transform: "translate(23.528 294.886)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25364",
    "data-name": "Rectangle 25364",
    width: 43.392,
    height: 10.396,
    transform: "translate(27.062 364.428)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25365",
    "data-name": "Rectangle 25365",
    width: 6.004,
    height: 5.44,
    transform: "translate(57.082 415.62)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25366",
    "data-name": "Rectangle 25366",
    width: 6.004,
    height: 2.72,
    transform: "translate(57.077 415.62)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25367",
    "data-name": "Rectangle 25367",
    width: 5.999,
    height: 5.44,
    transform: "translate(34.431 415.62)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25368",
    "data-name": "Rectangle 25368",
    width: 5.999,
    height: 2.72,
    transform: "translate(34.431 415.62)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275855",
    "data-name": "Path 275855",
    d: "M112.458,45.228a13.513,13.513,0,0,0,2.315-7.478c0-9.471-10.4-17.151-23.224-17.151S68.334,28.279,68.334,37.75,78.725,54.9,91.548,54.9a27.9,27.9,0,0,0,16.019-4.743l8,2.033Z",
    transform: "translate(269.616 81.273)",
    fill: "#fffdfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275856",
    "data-name": "Path 275856",
    d: "M112.825,45.541c6.325-9.332-1.973-20.272-11.493-22.779-9.342-2.987-20.638-1.409-27.725,5.5C65.441,35.892,69.863,47.94,79.363,52c8.877,4.233,20.143,3.838,28.422-1.736l.1-.069.109.03,7.967,2.161-.143.168Zm0,0,3.22,6.914.1.228-.242-.059-8.032-1.909c-7.295,5.623-19.965,6.39-28.9,2.067-10.124-4.238-14.96-17.146-6.1-25.237C80.451,20.358,92,18.959,101.549,22.1c9.743,2.572,18.046,14.179,11.276,23.437",
    transform: "translate(269.249 80.959)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275857",
    "data-name": "Path 275857",
    d: "M75.183,25.988a2.408,2.408,0,1,1-2.408-2.408,2.408,2.408,0,0,1,2.408,2.408",
    transform: "translate(277.633 93.034)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275858",
    "data-name": "Path 275858",
    d: "M77.359,25.988A2.408,2.408,0,1,1,74.95,23.58a2.408,2.408,0,0,1,2.408,2.408",
    transform: "translate(286.219 93.034)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275859",
    "data-name": "Path 275859",
    d: "M79.534,25.988a2.408,2.408,0,1,1-2.408-2.408,2.408,2.408,0,0,1,2.408,2.408",
    transform: "translate(294.8 93.034)",
    fill: "#1a2e35"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorHeader);
export default __webpack_public_path__ + "static/media/Mentor_Header.d842c1d0540633975cf79e9ab7a329fb.svg";
export { ForwardRef as ReactComponent };